var _defs, _g, _image, _g2, _image2, _g3, _image3, _g4, _image4, _g5, _image5, _g6, _image6, _g7, _image7, _g8, _image8, _g9, _image9, _g0, _image0, _g1, _image1, _g10, _image10, _g11, _image11, _g12, _image12, _g13, _image13, _g14, _image14, _path, _path2, _path3, _defs2, _g15, _defs3, _g16;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRaft6(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      background: "#ffffff",
      backgroundColor: "light-dark(#ffffff, var(--ge-dark-color, #121212))",
      colorScheme: "light dark"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "519px",
    height: "519px",
    viewBox: "0 0 519 519",
    content: "<mxfile host=\"app.diagrams.net\" agent=\"Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/145.0.0.0 Safari/537.36\" version=\"29.6.0\" scale=\"1\" border=\"0\"> <diagram name=\"Page-1\" id=\"zq2ZCigJnL9Pw6rQb8Gg\"> <mxGraphModel dx=\"777\" dy=\"671\" grid=\"1\" gridSize=\"10\" guides=\"1\" tooltips=\"1\" connect=\"1\" arrows=\"1\" fold=\"1\" page=\"1\" pageScale=\"1\" pageWidth=\"850\" pageHeight=\"1100\" math=\"0\" shadow=\"0\"> <root> <mxCell id=\"0\" /> <mxCell id=\"1\" parent=\"0\" /> <mxCell id=\"Tfl8lXNMB-wzWbKNDFm7-102\" parent=\"1\" style=\"text;html=1;whiteSpace=wrap;strokeColor=none;fillColor=none;align=center;verticalAlign=middle;rounded=0;\" value=\"1\" vertex=\"1\"> <mxGeometry height=\"22.848924731182795\" width=\"45.6981664315938\" x=\"68.0818053596615\" y=\"1266.9209677419356\" as=\"geometry\" /> </mxCell> <mxCell id=\"Tfl8lXNMB-wzWbKNDFm7-103\" parent=\"1\" style=\"text;html=1;whiteSpace=wrap;strokeColor=none;fillColor=none;align=center;verticalAlign=middle;rounded=0;\" value=\"2\" vertex=\"1\"> <mxGeometry height=\"22.848924731182795\" width=\"45.6981664315938\" x=\"129.0126939351199\" y=\"1266.9209677419356\" as=\"geometry\" /> </mxCell> <mxCell id=\"Tfl8lXNMB-wzWbKNDFm7-104\" parent=\"1\" style=\"text;html=1;whiteSpace=wrap;strokeColor=none;fillColor=none;align=center;verticalAlign=middle;rounded=0;\" value=\"3\" vertex=\"1\"> <mxGeometry height=\"22.848924731182795\" width=\"45.6981664315938\" x=\"189.9435825105783\" y=\"1266.9209677419356\" as=\"geometry\" /> </mxCell> <mxCell id=\"Tfl8lXNMB-wzWbKNDFm7-105\" parent=\"1\" style=\"text;html=1;whiteSpace=wrap;strokeColor=none;fillColor=none;align=center;verticalAlign=middle;rounded=0;\" value=\"4\" vertex=\"1\"> <mxGeometry height=\"22.848924731182795\" width=\"45.6981664315938\" x=\"250.8744710860367\" y=\"1266.9209677419356\" as=\"geometry\" /> </mxCell> <mxCell id=\"Tfl8lXNMB-wzWbKNDFm7-106\" parent=\"1\" style=\"text;html=1;whiteSpace=wrap;strokeColor=none;fillColor=none;align=center;verticalAlign=middle;rounded=0;\" value=\"5\" vertex=\"1\"> <mxGeometry height=\"22.848924731182795\" width=\"45.6981664315938\" x=\"311.80535966149506\" y=\"1266.9209677419356\" as=\"geometry\" /> </mxCell> <mxCell id=\"Tfl8lXNMB-wzWbKNDFm7-107\" parent=\"1\" style=\"text;html=1;whiteSpace=wrap;strokeColor=none;fillColor=none;align=center;verticalAlign=middle;rounded=0;\" value=\"6\" vertex=\"1\"> <mxGeometry height=\"22.848924731182795\" width=\"45.6981664315938\" x=\"372.7362482369535\" y=\"1266.9209677419356\" as=\"geometry\" /> </mxCell> <mxCell id=\"Tfl8lXNMB-wzWbKNDFm7-108\" parent=\"1\" style=\"text;html=1;whiteSpace=wrap;strokeColor=none;fillColor=none;align=center;verticalAlign=middle;rounded=0;\" value=\"7\" vertex=\"1\"> <mxGeometry height=\"22.848924731182795\" width=\"45.6981664315938\" x=\"433.66713681241185\" y=\"1266.9209677419356\" as=\"geometry\" /> </mxCell> <mxCell id=\"Tfl8lXNMB-wzWbKNDFm7-109\" parent=\"1\" style=\"text;html=1;whiteSpace=wrap;strokeColor=none;fillColor=none;align=center;verticalAlign=middle;rounded=0;\" value=\"8\" vertex=\"1\"> <mxGeometry height=\"22.848924731182795\" width=\"45.6981664315938\" x=\"494.5980253878703\" y=\"1266.9209677419356\" as=\"geometry\" /> </mxCell> <mxCell id=\"Tfl8lXNMB-wzWbKNDFm7-112\" parent=\"1\" style=\"text;html=1;whiteSpace=wrap;strokeColor=none;fillColor=none;align=center;verticalAlign=middle;rounded=0;\" value=\"A\" vertex=\"1\"> <mxGeometry height=\"22.848924731182795\" width=\"45.6981664315938\" x=\"30\" y=\"1217.414964157706\" as=\"geometry\" /> </mxCell> <mxCell id=\"Tfl8lXNMB-wzWbKNDFm7-114\" parent=\"1\" style=\"text;html=1;whiteSpace=wrap;strokeColor=none;fillColor=none;align=center;verticalAlign=middle;rounded=0;\" value=\"C\" vertex=\"1\"> <mxGeometry height=\"22.848924731182795\" width=\"45.6981664315938\" x=\"30\" y=\"1099.3621863799283\" as=\"geometry\" /> </mxCell> <mxCell id=\"Tfl8lXNMB-wzWbKNDFm7-115\" parent=\"1\" style=\"text;html=1;whiteSpace=wrap;strokeColor=none;fillColor=none;align=center;verticalAlign=middle;rounded=0;\" value=\"D\" vertex=\"1\"> <mxGeometry height=\"22.848924731182795\" width=\"45.6981664315938\" x=\"30\" y=\"1038.4317204301076\" as=\"geometry\" /> </mxCell> <mxCell id=\"Tfl8lXNMB-wzWbKNDFm7-116\" parent=\"1\" style=\"text;html=1;whiteSpace=wrap;strokeColor=none;fillColor=none;align=center;verticalAlign=middle;rounded=0;\" value=\"E\" vertex=\"1\"> <mxGeometry height=\"22.848924731182795\" width=\"45.6981664315938\" x=\"30\" y=\"977.5012544802867\" as=\"geometry\" /> </mxCell> <mxCell id=\"Tfl8lXNMB-wzWbKNDFm7-118\" parent=\"1\" style=\"text;html=1;whiteSpace=wrap;strokeColor=none;fillColor=none;align=center;verticalAlign=middle;rounded=0;\" value=\"G\" vertex=\"1\"> <mxGeometry height=\"22.848924731182795\" width=\"45.6981664315938\" x=\"30\" y=\"855.6403225806451\" as=\"geometry\" /> </mxCell> <mxCell id=\"Tfl8lXNMB-wzWbKNDFm7-119\" parent=\"1\" style=\"text;html=1;whiteSpace=wrap;strokeColor=none;fillColor=none;align=center;verticalAlign=middle;rounded=0;\" value=\"H\" vertex=\"1\"> <mxGeometry height=\"22.848924731182795\" width=\"45.6981664315938\" x=\"30\" y=\"794.7098566308243\" as=\"geometry\" /> </mxCell> <mxCell id=\"Tfl8lXNMB-wzWbKNDFm7-21\" parent=\"1\" style=\"whiteSpace=wrap;html=1;aspect=fixed;fillColor=#cdeb8b;strokeColor=#36393d;\" value=\"\" vertex=\"1\"> <mxGeometry height=\"60.93046594982079\" width=\"60.93046594982079\" x=\"243.25811001410437\" y=\"771.8609318996416\" as=\"geometry\" /> </mxCell> <mxCell id=\"Tfl8lXNMB-wzWbKNDFm7-22\" parent=\"1\" style=\"whiteSpace=wrap;html=1;aspect=fixed;fillColor=#cdeb8b;strokeColor=#36393d;\" value=\"\" vertex=\"1\"> <mxGeometry height=\"60.93046594982079\" width=\"60.93046594982079\" x=\"304.1889985895628\" y=\"771.8609318996416\" as=\"geometry\" /> </mxCell> <mxCell id=\"Tfl8lXNMB-wzWbKNDFm7-23\" parent=\"1\" style=\"whiteSpace=wrap;html=1;aspect=fixed;fillColor=#cdeb8b;strokeColor=#36393d;\" value=\"\" vertex=\"1\"> <mxGeometry height=\"60.93046594982079\" width=\"60.93046594982079\" x=\"365.11988716502117\" y=\"771.8609318996416\" as=\"geometry\" /> </mxCell> <mxCell id=\"Tfl8lXNMB-wzWbKNDFm7-24\" parent=\"1\" style=\"whiteSpace=wrap;html=1;aspect=fixed;fillColor=#cdeb8b;strokeColor=#36393d;\" value=\"\" vertex=\"1\"> <mxGeometry height=\"60.93046594982079\" width=\"60.93046594982079\" x=\"426.0507757404796\" y=\"771.8609318996416\" as=\"geometry\" /> </mxCell> <mxCell id=\"Tfl8lXNMB-wzWbKNDFm7-25\" parent=\"1\" style=\"whiteSpace=wrap;html=1;aspect=fixed;fillColor=#cdeb8b;strokeColor=#36393d;\" value=\"\" vertex=\"1\"> <mxGeometry height=\"60.93046594982079\" width=\"60.93046594982079\" x=\"486.98166431593796\" y=\"771.8609318996416\" as=\"geometry\" /> </mxCell> <mxCell id=\"Tfl8lXNMB-wzWbKNDFm7-27\" parent=\"1\" style=\"whiteSpace=wrap;html=1;aspect=fixed;fillColor=#cdeb8b;strokeColor=#36393d;\" value=\"\" vertex=\"1\"> <mxGeometry height=\"60.93046594982079\" width=\"60.93046594982079\" x=\"182.327221438646\" y=\"771.8609318996416\" as=\"geometry\" /> </mxCell> <mxCell id=\"Tfl8lXNMB-wzWbKNDFm7-29\" parent=\"1\" style=\"whiteSpace=wrap;html=1;aspect=fixed;fillColor=#cdeb8b;strokeColor=#36393d;\" value=\"\" vertex=\"1\"> <mxGeometry height=\"60.93046594982079\" width=\"60.93046594982079\" x=\"60.4654442877292\" y=\"771.8609318996416\" as=\"geometry\" /> </mxCell> <mxCell id=\"Tfl8lXNMB-wzWbKNDFm7-31\" parent=\"1\" style=\"whiteSpace=wrap;html=1;aspect=fixed;fillColor=#cdeb8b;strokeColor=#36393d;\" value=\"\" vertex=\"1\"> <mxGeometry height=\"60.93046594982079\" width=\"60.93046594982079\" x=\"243.25811001410437\" y=\"832.7913978494623\" as=\"geometry\" /> </mxCell> <mxCell id=\"Tfl8lXNMB-wzWbKNDFm7-32\" parent=\"1\" style=\"whiteSpace=wrap;html=1;aspect=fixed;fillColor=#cdeb8b;strokeColor=#36393d;\" value=\"\" vertex=\"1\"> <mxGeometry height=\"60.93046594982079\" width=\"60.93046594982079\" x=\"304.1889985895628\" y=\"832.7913978494623\" as=\"geometry\" /> </mxCell> <mxCell id=\"Tfl8lXNMB-wzWbKNDFm7-33\" parent=\"1\" style=\"whiteSpace=wrap;html=1;aspect=fixed;fillColor=#cdeb8b;strokeColor=#36393d;\" value=\"\" vertex=\"1\"> <mxGeometry height=\"60.93046594982079\" width=\"60.93046594982079\" x=\"365.11988716502117\" y=\"832.7913978494623\" as=\"geometry\" /> </mxCell> <mxCell id=\"Tfl8lXNMB-wzWbKNDFm7-34\" parent=\"1\" style=\"whiteSpace=wrap;html=1;aspect=fixed;fillColor=#cdeb8b;strokeColor=#36393d;\" value=\"\" vertex=\"1\"> <mxGeometry height=\"60.93046594982079\" width=\"60.93046594982079\" x=\"426.0507757404796\" y=\"832.7913978494623\" as=\"geometry\" /> </mxCell> <mxCell id=\"Tfl8lXNMB-wzWbKNDFm7-35\" parent=\"1\" style=\"whiteSpace=wrap;html=1;aspect=fixed;fillColor=#cdeb8b;strokeColor=#36393d;\" value=\"\" vertex=\"1\"> <mxGeometry height=\"60.93046594982079\" width=\"60.93046594982079\" x=\"486.98166431593796\" y=\"832.7913978494623\" as=\"geometry\" /> </mxCell> <mxCell id=\"Tfl8lXNMB-wzWbKNDFm7-37\" parent=\"1\" style=\"whiteSpace=wrap;html=1;aspect=fixed;fillColor=#cdeb8b;strokeColor=#36393d;\" value=\"\" vertex=\"1\"> <mxGeometry height=\"60.93046594982079\" width=\"60.93046594982079\" x=\"182.327221438646\" y=\"832.7913978494623\" as=\"geometry\" /> </mxCell> <mxCell id=\"Tfl8lXNMB-wzWbKNDFm7-38\" parent=\"1\" style=\"whiteSpace=wrap;html=1;aspect=fixed;fillColor=#ffcccc;strokeColor=none;\" value=\"\" vertex=\"1\"> <mxGeometry height=\"60.93046594982079\" width=\"60.93046594982079\" x=\"121.3963328631876\" y=\"832.7913978494623\" as=\"geometry\" /> </mxCell> <mxCell id=\"Tfl8lXNMB-wzWbKNDFm7-39\" parent=\"1\" style=\"whiteSpace=wrap;html=1;aspect=fixed;fillColor=#cdeb8b;strokeColor=#36393d;\" value=\"\" vertex=\"1\"> <mxGeometry height=\"60.93046594982079\" width=\"60.93046594982079\" x=\"60.4654442877292\" y=\"832.7913978494623\" as=\"geometry\" /> </mxCell> <mxCell id=\"Tfl8lXNMB-wzWbKNDFm7-41\" parent=\"1\" style=\"whiteSpace=wrap;html=1;aspect=fixed;fillColor=#cdeb8b;strokeColor=#36393d;\" value=\"\" vertex=\"1\"> <mxGeometry height=\"60.93046594982079\" width=\"60.93046594982079\" x=\"243.25811001410437\" y=\"893.7218637992831\" as=\"geometry\" /> </mxCell> <mxCell id=\"Tfl8lXNMB-wzWbKNDFm7-42\" parent=\"1\" style=\"whiteSpace=wrap;html=1;aspect=fixed;fillColor=#cdeb8b;strokeColor=#36393d;\" value=\"\" vertex=\"1\"> <mxGeometry height=\"60.93046594982079\" width=\"60.93046594982079\" x=\"304.1889985895628\" y=\"893.7218637992831\" as=\"geometry\" /> </mxCell> <mxCell id=\"Tfl8lXNMB-wzWbKNDFm7-43\" parent=\"1\" style=\"whiteSpace=wrap;html=1;aspect=fixed;fillColor=#cdeb8b;strokeColor=#36393d;\" value=\"\" vertex=\"1\"> <mxGeometry height=\"60.93046594982079\" width=\"60.93046594982079\" x=\"365.11988716502117\" y=\"893.7218637992831\" as=\"geometry\" /> </mxCell> <mxCell id=\"Tfl8lXNMB-wzWbKNDFm7-44\" parent=\"1\" style=\"whiteSpace=wrap;html=1;aspect=fixed;fillColor=#cdeb8b;strokeColor=#36393d;\" value=\"\" vertex=\"1\"> <mxGeometry height=\"60.93046594982079\" width=\"60.93046594982079\" x=\"426.0507757404796\" y=\"893.7218637992831\" as=\"geometry\" /> </mxCell> <mxCell id=\"Tfl8lXNMB-wzWbKNDFm7-45\" parent=\"1\" style=\"whiteSpace=wrap;html=1;aspect=fixed;fillColor=#cdeb8b;strokeColor=#36393d;\" value=\"\" vertex=\"1\"> <mxGeometry height=\"60.93046594982079\" width=\"60.93046594982079\" x=\"486.98166431593796\" y=\"893.7218637992831\" as=\"geometry\" /> </mxCell> <mxCell id=\"Tfl8lXNMB-wzWbKNDFm7-47\" parent=\"1\" style=\"whiteSpace=wrap;html=1;aspect=fixed;fillColor=#cdeb8b;strokeColor=#36393d;\" value=\"\" vertex=\"1\"> <mxGeometry height=\"60.93046594982079\" width=\"60.93046594982079\" x=\"182.327221438646\" y=\"893.7218637992831\" as=\"geometry\" /> </mxCell> <mxCell id=\"Tfl8lXNMB-wzWbKNDFm7-48\" parent=\"1\" style=\"whiteSpace=wrap;html=1;aspect=fixed;fillColor=#cdeb8b;strokeColor=#36393d;\" value=\"\" vertex=\"1\"> <mxGeometry height=\"60.93046594982079\" width=\"60.93046594982079\" x=\"121.3963328631876\" y=\"893.7218637992831\" as=\"geometry\" /> </mxCell> <mxCell id=\"Tfl8lXNMB-wzWbKNDFm7-49\" parent=\"1\" style=\"whiteSpace=wrap;html=1;aspect=fixed;fillColor=#cdeb8b;strokeColor=#36393d;\" value=\"\" vertex=\"1\"> <mxGeometry height=\"60.93046594982079\" width=\"60.93046594982079\" x=\"60.4654442877292\" y=\"893.7218637992831\" as=\"geometry\" /> </mxCell> <mxCell id=\"Tfl8lXNMB-wzWbKNDFm7-51\" parent=\"1\" style=\"whiteSpace=wrap;html=1;aspect=fixed;fillColor=#cdeb8b;strokeColor=#36393d;\" value=\"\" vertex=\"1\"> <mxGeometry height=\"60.93046594982079\" width=\"60.93046594982079\" x=\"243.25811001410437\" y=\"954.652329749104\" as=\"geometry\" /> </mxCell> <mxCell id=\"Tfl8lXNMB-wzWbKNDFm7-52\" parent=\"1\" style=\"whiteSpace=wrap;html=1;aspect=fixed;fillColor=#cdeb8b;strokeColor=#36393d;\" value=\"\" vertex=\"1\"> <mxGeometry height=\"60.93046594982079\" width=\"60.93046594982079\" x=\"304.1889985895628\" y=\"954.652329749104\" as=\"geometry\" /> </mxCell> <mxCell id=\"Tfl8lXNMB-wzWbKNDFm7-53\" parent=\"1\" style=\"whiteSpace=wrap;html=1;aspect=fixed;fillColor=#cdeb8b;strokeColor=#36393d;\" value=\"\" vertex=\"1\"> <mxGeometry height=\"60.93046594982079\" width=\"60.93046594982079\" x=\"365.11988716502117\" y=\"954.652329749104\" as=\"geometry\" /> </mxCell> <mxCell id=\"Tfl8lXNMB-wzWbKNDFm7-54\" parent=\"1\" style=\"whiteSpace=wrap;html=1;aspect=fixed;fillColor=#cdeb8b;strokeColor=#36393d;\" value=\"\" vertex=\"1\"> <mxGeometry height=\"60.93046594982079\" width=\"60.93046594982079\" x=\"426.0507757404796\" y=\"954.652329749104\" as=\"geometry\" /> </mxCell> <mxCell id=\"Tfl8lXNMB-wzWbKNDFm7-55\" parent=\"1\" style=\"whiteSpace=wrap;html=1;aspect=fixed;fillColor=#cdeb8b;strokeColor=#36393d;\" value=\"\" vertex=\"1\"> <mxGeometry height=\"60.93046594982079\" width=\"60.93046594982079\" x=\"486.98166431593796\" y=\"954.652329749104\" as=\"geometry\" /> </mxCell> <mxCell id=\"Tfl8lXNMB-wzWbKNDFm7-57\" parent=\"1\" style=\"whiteSpace=wrap;html=1;aspect=fixed;fillColor=#cdeb8b;strokeColor=#36393d;\" value=\"\" vertex=\"1\"> <mxGeometry height=\"60.93046594982079\" width=\"60.93046594982079\" x=\"182.327221438646\" y=\"954.652329749104\" as=\"geometry\" /> </mxCell> <mxCell id=\"Tfl8lXNMB-wzWbKNDFm7-58\" parent=\"1\" style=\"whiteSpace=wrap;html=1;aspect=fixed;fillColor=#cdeb8b;strokeColor=#36393d;\" value=\"\" vertex=\"1\"> <mxGeometry height=\"60.93046594982079\" width=\"60.93046594982079\" x=\"121.3963328631876\" y=\"954.652329749104\" as=\"geometry\" /> </mxCell> <mxCell id=\"Tfl8lXNMB-wzWbKNDFm7-59\" parent=\"1\" style=\"whiteSpace=wrap;html=1;aspect=fixed;fillColor=#cdeb8b;strokeColor=#36393d;\" value=\"\" vertex=\"1\"> <mxGeometry height=\"60.93046594982079\" width=\"60.93046594982079\" x=\"60.4654442877292\" y=\"954.652329749104\" as=\"geometry\" /> </mxCell> <mxCell id=\"Tfl8lXNMB-wzWbKNDFm7-61\" parent=\"1\" style=\"whiteSpace=wrap;html=1;aspect=fixed;fillColor=#cdeb8b;strokeColor=#36393d;\" value=\"\" vertex=\"1\"> <mxGeometry height=\"60.93046594982079\" width=\"60.93046594982079\" x=\"243.25811001410437\" y=\"1015.5827956989247\" as=\"geometry\" /> </mxCell> <mxCell id=\"Tfl8lXNMB-wzWbKNDFm7-62\" parent=\"1\" style=\"whiteSpace=wrap;html=1;aspect=fixed;fillColor=#cdeb8b;strokeColor=#36393d;\" value=\"\" vertex=\"1\"> <mxGeometry height=\"60.93046594982079\" width=\"60.93046594982079\" x=\"304.1889985895628\" y=\"1015.5827956989247\" as=\"geometry\" /> </mxCell> <mxCell id=\"Tfl8lXNMB-wzWbKNDFm7-63\" parent=\"1\" style=\"whiteSpace=wrap;html=1;aspect=fixed;fillColor=#ffcccc;strokeColor=#36393d;\" value=\"\" vertex=\"1\"> <mxGeometry height=\"60.93046594982079\" width=\"60.93046594982079\" x=\"365.11988716502117\" y=\"1015.5827956989247\" as=\"geometry\" /> </mxCell> <mxCell id=\"Tfl8lXNMB-wzWbKNDFm7-64\" parent=\"1\" style=\"whiteSpace=wrap;html=1;aspect=fixed;fillColor=#ffcccc;strokeColor=#36393d;\" value=\"\" vertex=\"1\"> <mxGeometry height=\"60.93046594982079\" width=\"60.93046594982079\" x=\"426.0507757404796\" y=\"1015.5827956989247\" as=\"geometry\" /> </mxCell> <mxCell id=\"Tfl8lXNMB-wzWbKNDFm7-65\" parent=\"1\" style=\"whiteSpace=wrap;html=1;aspect=fixed;fillColor=#ffcccc;strokeColor=#36393d;\" value=\"\" vertex=\"1\"> <mxGeometry height=\"60.93046594982079\" width=\"60.93046594982079\" x=\"486.98166431593796\" y=\"1015.5827956989247\" as=\"geometry\" /> </mxCell> <mxCell id=\"Tfl8lXNMB-wzWbKNDFm7-67\" parent=\"1\" style=\"whiteSpace=wrap;html=1;aspect=fixed;fillColor=#cdeb8b;strokeColor=#36393d;\" value=\"\" vertex=\"1\"> <mxGeometry height=\"60.93046594982079\" width=\"60.93046594982079\" x=\"182.327221438646\" y=\"1015.5827956989247\" as=\"geometry\" /> </mxCell> <mxCell id=\"Tfl8lXNMB-wzWbKNDFm7-68\" parent=\"1\" style=\"whiteSpace=wrap;html=1;aspect=fixed;fillColor=#cdeb8b;strokeColor=#36393d;\" value=\"\" vertex=\"1\"> <mxGeometry height=\"60.93046594982079\" width=\"60.93046594982079\" x=\"121.3963328631876\" y=\"1015.5827956989247\" as=\"geometry\" /> </mxCell> <mxCell id=\"Tfl8lXNMB-wzWbKNDFm7-69\" parent=\"1\" style=\"whiteSpace=wrap;html=1;aspect=fixed;fillColor=#cdeb8b;strokeColor=#36393d;\" value=\"\" vertex=\"1\"> <mxGeometry height=\"60.93046594982079\" width=\"60.93046594982079\" x=\"60.4654442877292\" y=\"1015.5827956989247\" as=\"geometry\" /> </mxCell> <mxCell id=\"Tfl8lXNMB-wzWbKNDFm7-71\" parent=\"1\" style=\"whiteSpace=wrap;html=1;aspect=fixed;fillColor=#ffcc99;strokeColor=#36393d;\" value=\"\" vertex=\"1\"> <mxGeometry height=\"60.93046594982079\" width=\"60.93046594982079\" x=\"243.25811001410437\" y=\"1076.5132616487456\" as=\"geometry\" /> </mxCell> <mxCell id=\"Tfl8lXNMB-wzWbKNDFm7-72\" parent=\"1\" style=\"whiteSpace=wrap;html=1;aspect=fixed;fillColor=#ffcc99;strokeColor=#36393d;\" value=\"\" vertex=\"1\"> <mxGeometry height=\"60.93046594982079\" width=\"60.93046594982079\" x=\"304.1889985895628\" y=\"1076.5132616487456\" as=\"geometry\" /> </mxCell> <mxCell id=\"Tfl8lXNMB-wzWbKNDFm7-73\" parent=\"1\" style=\"whiteSpace=wrap;html=1;aspect=fixed;fillColor=#ffcccc;strokeColor=#36393d;\" value=\"\" vertex=\"1\"> <mxGeometry height=\"60.93046594982079\" width=\"60.93046594982079\" x=\"365.11988716502117\" y=\"1076.5132616487456\" as=\"geometry\" /> </mxCell> <mxCell id=\"Tfl8lXNMB-wzWbKNDFm7-74\" parent=\"1\" style=\"whiteSpace=wrap;html=1;aspect=fixed;fillColor=#ffcccc;strokeColor=#36393d;\" value=\"\" vertex=\"1\"> <mxGeometry height=\"60.93046594982079\" width=\"60.93046594982079\" x=\"426.0507757404796\" y=\"1076.5132616487456\" as=\"geometry\" /> </mxCell> <mxCell id=\"Tfl8lXNMB-wzWbKNDFm7-75\" parent=\"1\" style=\"whiteSpace=wrap;html=1;aspect=fixed;fillColor=#ffcccc;strokeColor=#36393d;\" value=\"\" vertex=\"1\"> <mxGeometry height=\"60.93046594982079\" width=\"60.93046594982079\" x=\"486.98166431593796\" y=\"1076.5132616487456\" as=\"geometry\" /> </mxCell> <mxCell id=\"Tfl8lXNMB-wzWbKNDFm7-77\" parent=\"1\" style=\"whiteSpace=wrap;html=1;aspect=fixed;fillColor=#cdeb8b;strokeColor=#36393d;\" value=\"\" vertex=\"1\"> <mxGeometry height=\"60.93046594982079\" width=\"60.93046594982079\" x=\"182.327221438646\" y=\"1076.5132616487456\" as=\"geometry\" /> </mxCell> <mxCell id=\"Tfl8lXNMB-wzWbKNDFm7-78\" parent=\"1\" style=\"whiteSpace=wrap;html=1;aspect=fixed;fillColor=#cdeb8b;strokeColor=#36393d;\" value=\"\" vertex=\"1\"> <mxGeometry height=\"60.93046594982079\" width=\"60.93046594982079\" x=\"121.3963328631876\" y=\"1076.5132616487456\" as=\"geometry\" /> </mxCell> <mxCell id=\"Tfl8lXNMB-wzWbKNDFm7-79\" parent=\"1\" style=\"whiteSpace=wrap;html=1;aspect=fixed;fillColor=#cdeb8b;strokeColor=#36393d;\" value=\"\" vertex=\"1\"> <mxGeometry height=\"60.93046594982079\" width=\"60.93046594982079\" x=\"60.4654442877292\" y=\"1076.5132616487456\" as=\"geometry\" /> </mxCell> <mxCell id=\"Tfl8lXNMB-wzWbKNDFm7-81\" parent=\"1\" style=\"whiteSpace=wrap;html=1;aspect=fixed;fillColor=#ffcc99;strokeColor=#36393d;\" value=\"\" vertex=\"1\"> <mxGeometry height=\"60.93046594982079\" width=\"60.93046594982079\" x=\"243.25811001410437\" y=\"1137.4437275985663\" as=\"geometry\" /> </mxCell> <mxCell id=\"Tfl8lXNMB-wzWbKNDFm7-82\" parent=\"1\" style=\"whiteSpace=wrap;html=1;aspect=fixed;fillColor=#ffcc99;strokeColor=#36393d;\" value=\"\" vertex=\"1\"> <mxGeometry height=\"60.93046594982079\" width=\"60.93046594982079\" x=\"304.1889985895628\" y=\"1137.4437275985663\" as=\"geometry\" /> </mxCell> <mxCell id=\"Tfl8lXNMB-wzWbKNDFm7-83\" parent=\"1\" style=\"whiteSpace=wrap;html=1;aspect=fixed;fillColor=#ffcc99;strokeColor=#36393d;\" value=\"\" vertex=\"1\"> <mxGeometry height=\"60.93046594982079\" width=\"60.93046594982079\" x=\"365.11988716502117\" y=\"1137.4437275985663\" as=\"geometry\" /> </mxCell> <mxCell id=\"Tfl8lXNMB-wzWbKNDFm7-84\" parent=\"1\" style=\"whiteSpace=wrap;html=1;aspect=fixed;fillColor=#ffcccc;strokeColor=#36393d;\" value=\"\" vertex=\"1\"> <mxGeometry height=\"60.93046594982079\" width=\"60.93046594982079\" x=\"426.0507757404796\" y=\"1137.4437275985663\" as=\"geometry\" /> </mxCell> <mxCell id=\"Tfl8lXNMB-wzWbKNDFm7-85\" parent=\"1\" style=\"whiteSpace=wrap;html=1;aspect=fixed;fillColor=#ffcccc;strokeColor=#36393d;\" value=\"\" vertex=\"1\"> <mxGeometry height=\"60.93046594982079\" width=\"60.93046594982079\" x=\"486.98166431593796\" y=\"1137.4437275985663\" as=\"geometry\" /> </mxCell> <mxCell id=\"Tfl8lXNMB-wzWbKNDFm7-87\" parent=\"1\" style=\"whiteSpace=wrap;html=1;aspect=fixed;fillColor=#ffcc99;strokeColor=#36393d;\" value=\"\" vertex=\"1\"> <mxGeometry height=\"60.93046594982079\" width=\"60.93046594982079\" x=\"182.327221438646\" y=\"1137.4437275985663\" as=\"geometry\" /> </mxCell> <mxCell id=\"Tfl8lXNMB-wzWbKNDFm7-88\" parent=\"1\" style=\"whiteSpace=wrap;html=1;aspect=fixed;fillColor=#ffcc99;strokeColor=#36393d;\" value=\"\" vertex=\"1\"> <mxGeometry height=\"60.93046594982079\" width=\"60.93046594982079\" x=\"121.3963328631876\" y=\"1137.4437275985663\" as=\"geometry\" /> </mxCell> <mxCell id=\"Tfl8lXNMB-wzWbKNDFm7-89\" parent=\"1\" style=\"whiteSpace=wrap;html=1;aspect=fixed;fillColor=#cdeb8b;strokeColor=#36393d;\" value=\"\" vertex=\"1\"> <mxGeometry height=\"60.93046594982079\" width=\"60.93046594982079\" x=\"60.4654442877292\" y=\"1137.4437275985663\" as=\"geometry\" /> </mxCell> <mxCell id=\"Tfl8lXNMB-wzWbKNDFm7-91\" parent=\"1\" style=\"whiteSpace=wrap;html=1;aspect=fixed;fillColor=#ffcc99;strokeColor=#36393d;\" value=\"\" vertex=\"1\"> <mxGeometry height=\"60.93046594982079\" width=\"60.93046594982079\" x=\"243.25811001410437\" y=\"1198.3741935483872\" as=\"geometry\" /> </mxCell> <mxCell id=\"Tfl8lXNMB-wzWbKNDFm7-92\" parent=\"1\" style=\"whiteSpace=wrap;html=1;aspect=fixed;fillColor=#ffcc99;strokeColor=#36393d;\" value=\"\" vertex=\"1\"> <mxGeometry height=\"60.93046594982079\" width=\"60.93046594982079\" x=\"304.1889985895628\" y=\"1198.3741935483872\" as=\"geometry\" /> </mxCell> <mxCell id=\"Tfl8lXNMB-wzWbKNDFm7-93\" parent=\"1\" style=\"whiteSpace=wrap;html=1;aspect=fixed;fillColor=#ffcc99;strokeColor=#36393d;\" value=\"\" vertex=\"1\"> <mxGeometry height=\"60.93046594982079\" width=\"60.93046594982079\" x=\"365.11988716502117\" y=\"1198.3741935483872\" as=\"geometry\" /> </mxCell> <mxCell id=\"Tfl8lXNMB-wzWbKNDFm7-94\" parent=\"1\" style=\"whiteSpace=wrap;html=1;aspect=fixed;fillColor=#ffcccc;strokeColor=#36393d;\" value=\"\" vertex=\"1\"> <mxGeometry height=\"60.93046594982079\" width=\"60.93046594982079\" x=\"426.0507757404796\" y=\"1198.3741935483872\" as=\"geometry\" /> </mxCell> <mxCell id=\"Tfl8lXNMB-wzWbKNDFm7-95\" parent=\"1\" style=\"whiteSpace=wrap;html=1;aspect=fixed;fillColor=#ffcccc;strokeColor=#36393d;\" value=\"\" vertex=\"1\"> <mxGeometry height=\"60.93046594982079\" width=\"60.93046594982079\" x=\"486.98166431593796\" y=\"1198.3741935483872\" as=\"geometry\" /> </mxCell> <mxCell id=\"Tfl8lXNMB-wzWbKNDFm7-97\" parent=\"1\" style=\"whiteSpace=wrap;html=1;aspect=fixed;fillColor=#ffcc99;strokeColor=#36393d;\" value=\"\" vertex=\"1\"> <mxGeometry height=\"60.93046594982079\" width=\"60.93046594982079\" x=\"182.327221438646\" y=\"1198.3741935483872\" as=\"geometry\" /> </mxCell> <mxCell id=\"Tfl8lXNMB-wzWbKNDFm7-98\" parent=\"1\" style=\"whiteSpace=wrap;html=1;aspect=fixed;fillColor=#ffcc99;strokeColor=#36393d;\" value=\"\" vertex=\"1\"> <mxGeometry height=\"60.93046594982079\" width=\"60.93046594982079\" x=\"121.3963328631876\" y=\"1198.3741935483872\" as=\"geometry\" /> </mxCell> <mxCell id=\"Tfl8lXNMB-wzWbKNDFm7-99\" parent=\"1\" style=\"whiteSpace=wrap;html=1;aspect=fixed;fillColor=#ffcc99;strokeColor=#36393d;\" value=\"\" vertex=\"1\"> <mxGeometry height=\"60.93046594982079\" width=\"60.93046594982079\" x=\"60.4654442877292\" y=\"1198.3741935483872\" as=\"geometry\" /> </mxCell> <mxCell id=\"Tfl8lXNMB-wzWbKNDFm7-113\" parent=\"1\" style=\"text;html=1;whiteSpace=wrap;strokeColor=none;fillColor=none;align=center;verticalAlign=middle;rounded=0;\" value=\"B\" vertex=\"1\"> <mxGeometry height=\"22.848924731182795\" width=\"45.6981664315938\" x=\"30\" y=\"1156.4844982078853\" as=\"geometry\" /> </mxCell> <mxCell id=\"Tfl8lXNMB-wzWbKNDFm7-117\" parent=\"1\" style=\"text;html=1;whiteSpace=wrap;strokeColor=none;fillColor=none;align=center;verticalAlign=middle;rounded=0;\" value=\"F\" vertex=\"1\"> <mxGeometry height=\"22.848924731182795\" width=\"45.6981664315938\" x=\"30\" y=\"912.7626344086021\" as=\"geometry\" /> </mxCell> <mxCell id=\"Tfl8lXNMB-wzWbKNDFm7-125\" parent=\"1\" style=\"shape=image;verticalLabelPosition=bottom;labelBackgroundColor=default;verticalAlign=top;aspect=fixed;imageAspect=0;editableCssRules=.*;image=data:image/svg+xml,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNTYuNDQ0NDU4MDA3ODEyNSIgaGVpZ2h0PSIxMTIuNDUwODUxNDQwNDI5NjkiIHZpZXdCb3g9IjExOSAxMzguNTQ5MTQ4NTU5NTcwMyAxNTYuNDQ0NDU4MDA3ODEyNSAxMTIuNDUwODUxNDQwNDI5NjkiIGZpbGw9Im5vbmUiPiYjeGE7PHBhdGggZD0iTTEyMCAxODBDMTIwIDE4MCAxMzUgMTU1IDE2MCAxNDVDMTg1IDEzNSAyMTAgMTQwIDIzMCAxNTBDMjUwIDE2MCAyNzAgMTgwIDI3MCAxODBDMjcwIDE4MCAyODAgMjAwIDI3MCAyMjBDMjYwIDI0MCAyMzAgMjUwIDIwMCAyNTBDMTcwIDI1MCAxNDAgMjQwIDEzMCAyMjBDMTIwIDIwMCAxMjAgMTgwIDEyMCAxODBaIiBmaWxsPSIjQTBBMEEwIiBzdHJva2U9IiM3MDcwNzAiIHN0cm9rZS13aWR0aD0iMiIvPiYjeGE7PC9zdmc+;\" value=\"\" vertex=\"1\"> <mxGeometry height=\"70.0700358422939\" width=\"97.59537383512544\" x=\"433.66713681241185\" y=\"1167.9089605734766\" as=\"geometry\" /> </mxCell> <mxCell id=\"Tfl8lXNMB-wzWbKNDFm7-126\" parent=\"1\" style=\"shape=image;verticalLabelPosition=bottom;labelBackgroundColor=default;verticalAlign=top;aspect=fixed;imageAspect=0;editableCssRules=.*;image=data:image/svg+xml,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNTYuNDQ0NDU4MDA3ODEyNSIgaGVpZ2h0PSIxMTIuNDUwODUxNDQwNDI5NjkiIHZpZXdCb3g9IjExOSAxMzguNTQ5MTQ4NTU5NTcwMyAxNTYuNDQ0NDU4MDA3ODEyNSAxMTIuNDUwODUxNDQwNDI5NjkiIGZpbGw9Im5vbmUiPiYjeGE7PHBhdGggZD0iTTEyMCAxODBDMTIwIDE4MCAxMzUgMTU1IDE2MCAxNDVDMTg1IDEzNSAyMTAgMTQwIDIzMCAxNTBDMjUwIDE2MCAyNzAgMTgwIDI3MCAxODBDMjcwIDE4MCAyODAgMjAwIDI3MCAyMjBDMjYwIDI0MCAyMzAgMjUwIDIwMCAyNTBDMTcwIDI1MCAxNDAgMjQwIDEzMCAyMjBDMTIwIDIwMCAxMjAgMTgwIDEyMCAxODBaIiBmaWxsPSIjQTBBMEEwIiBzdHJva2U9IiM3MDcwNzAiIHN0cm9rZS13aWR0aD0iMiIvPiYjeGE7PC9zdmc+;\" value=\"\" vertex=\"1\"> <mxGeometry height=\"92.95704211469534\" width=\"129.4772401433692\" x=\"387.96897038081806\" y=\"1029.2540689964158\" as=\"geometry\" /> </mxCell> <mxCell id=\"Tfl8lXNMB-wzWbKNDFm7-127\" parent=\"1\" style=\"shape=image;verticalLabelPosition=bottom;labelBackgroundColor=default;verticalAlign=top;aspect=fixed;imageAspect=0;editableCssRules=.*;image=data:image/svg+xml,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNTYuNDQ0NDU4MDA3ODEyNSIgaGVpZ2h0PSIxMTIuNDUwODUxNDQwNDI5NjkiIHZpZXdCb3g9IjExOSAxMzguNTQ5MTQ4NTU5NTcwMyAxNTYuNDQ0NDU4MDA3ODEyNSAxMTIuNDUwODUxNDQwNDI5NjkiIGZpbGw9Im5vbmUiPiYjeGE7PHBhdGggZD0iTTEyMCAxODBDMTIwIDE4MCAxMzUgMTU1IDE2MCAxNDVDMTg1IDEzNSAyMTAgMTQwIDIzMCAxNTBDMjUwIDE2MCAyNzAgMTgwIDI3MCAxODBDMjcwIDE4MCAyODAgMjAwIDI3MCAyMjBDMjYwIDI0MCAyMzAgMjUwIDIwMCAyNTBDMTcwIDI1MCAxNDAgMjQwIDEzMCAyMjBDMTIwIDIwMCAxMjAgMTgwIDEyMCAxODBaIiBmaWxsPSIjQTBBMEEwIiBzdHJva2U9IiM3MDcwNzAiIHN0cm9rZS13aWR0aD0iMiIvPiYjeGE7PC9zdmc+;\" value=\"\" vertex=\"1\"> <mxGeometry height=\"30.39\" width=\"42.33\" x=\"130.7\" y=\"851.87\" as=\"geometry\" /> </mxCell> <mxCell id=\"Tfl8lXNMB-wzWbKNDFm7-131\" parent=\"1\" style=\"shape=image;verticalLabelPosition=bottom;labelBackgroundColor=default;verticalAlign=top;aspect=fixed;imageAspect=0;editableCssRules=.*;image=data:image/svg+xml,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0NDQiIGhlaWdodD0iMTA0IiB2aWV3Qm94PSIyOCA0OCA0NDQgMTA0Ij4mI3hhOyAgPGRlZnM+JiN4YTsgICAgPG1hcmtlciBpZD0iYXJyb3doZWFkIiB2aWV3Qm94PSIwIDAgMTAgMTAiIHJlZlg9IjgiIHJlZlk9IjUiIG1hcmtlcldpZHRoPSI2IiBtYXJrZXJIZWlnaHQ9IjYiIG9yaWVudD0iYXV0byI+JiN4YTsgICAgICA8cGF0aCBkPSJNIDAgMiBMIDEwIDUgTCAwIDggWiIgZmlsbD0iIzRBOTBFMiIvPiYjeGE7ICAgIDwvbWFya2VyPiYjeGE7ICA8L2RlZnM+JiN4YTsmI3hhOyAgPGcgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjNEE5MEUyIiBzdHJva2Utd2lkdGg9IjQiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgbWFya2VyLWVuZD0idXJsKCNhcnJvd2hlYWQpIj4mI3hhOyAgICA8cGF0aCBkPSJNIDUwIDYwIFEgMTAwIDQwIDE1MCA2MCBUIDI1MCA2MCBUIDM1MCA2MCBUIDQ1MCA2MCIvPiYjeGE7ICAgICYjeGE7ICAgIDxwYXRoIGQ9Ik0gMzAgMTAwIFEgODAgODAgMTMwIDEwMCBUIDIzMCAxMDAgVCAzMzAgMTAwIFQgNDMwIDEwMCIvPiYjeGE7ICAgICYjeGE7ICAgIDxwYXRoIGQ9Ik0gNzAgMTQwIFEgMTIwIDEyMCAxNzAgMTQwIFQgMjcwIDE0MCBUIDM3MCAxNDAgVCA0NzAgMTQwIi8+JiN4YTsgIDwvZz4mI3hhOzwvc3ZnPg==;\" value=\"\" vertex=\"1\"> <mxGeometry height=\"66.00292724014336\" width=\"281.80340501792114\" x=\"68.0818053596615\" y=\"1033.861935483871\" as=\"geometry\" /> </mxCell> <mxCell id=\"Tfl8lXNMB-wzWbKNDFm7-132\" parent=\"1\" style=\"shape=image;verticalLabelPosition=bottom;labelBackgroundColor=default;verticalAlign=top;aspect=fixed;imageAspect=0;editableCssRules=.*;image=data:image/svg+xml,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0NDQiIGhlaWdodD0iMTA0IiB2aWV3Qm94PSIyOCA0OCA0NDQgMTA0Ij4mI3hhOyAgPGRlZnM+JiN4YTsgICAgPG1hcmtlciBpZD0iYXJyb3doZWFkIiB2aWV3Qm94PSIwIDAgMTAgMTAiIHJlZlg9IjgiIHJlZlk9IjUiIG1hcmtlcldpZHRoPSI2IiBtYXJrZXJIZWlnaHQ9IjYiIG9yaWVudD0iYXV0byI+JiN4YTsgICAgICA8cGF0aCBkPSJNIDAgMiBMIDEwIDUgTCAwIDggWiIgZmlsbD0iIzRBOTBFMiIvPiYjeGE7ICAgIDwvbWFya2VyPiYjeGE7ICA8L2RlZnM+JiN4YTsmI3hhOyAgPGcgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjNEE5MEUyIiBzdHJva2Utd2lkdGg9IjQiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgbWFya2VyLWVuZD0idXJsKCNhcnJvd2hlYWQpIj4mI3hhOyAgICA8cGF0aCBkPSJNIDUwIDYwIFEgMTAwIDQwIDE1MCA2MCBUIDI1MCA2MCBUIDM1MCA2MCBUIDQ1MCA2MCIvPiYjeGE7ICAgICYjeGE7ICAgIDxwYXRoIGQ9Ik0gMzAgMTAwIFEgODAgODAgMTMwIDEwMCBUIDIzMCAxMDAgVCAzMzAgMTAwIFQgNDMwIDEwMCIvPiYjeGE7ICAgICYjeGE7ICAgIDxwYXRoIGQ9Ik0gNzAgMTQwIFEgMTIwIDEyMCAxNzAgMTQwIFQgMjcwIDE0MCBUIDM3MCAxNDAgVCA0NzAgMTQwIi8+JiN4YTsgIDwvZz4mI3hhOzwvc3ZnPg==;\" value=\"\" vertex=\"1\"> <mxGeometry height=\"80.26827258064516\" width=\"342.73387096774195\" x=\"75.69816643159379\" y=\"1145.7150383512544\" as=\"geometry\" /> </mxCell> <mxCell id=\"SbbP0l1plqLaMQE0WqTQ-5\" parent=\"1\" style=\"whiteSpace=wrap;html=1;aspect=fixed;fillColor=#cdeb8b;strokeColor=#36393d;\" value=\"\" vertex=\"1\"> <mxGeometry height=\"60.93046594982079\" width=\"60.93046594982079\" x=\"121.4\" y=\"771.86\" as=\"geometry\" /> </mxCell> </root> </mxGraphModel> </diagram>\n</mxfile>\n",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("rect", {
    fill: "#ffffff",
    width: "100%",
    height: "100%",
    x: 0,
    y: 0,
    style: {
      fill: "light-dark(#ffffff, var(--ge-dark-color, #121212))"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    "data-cell-id": 0
  }, /*#__PURE__*/React.createElement("g", {
    "data-cell-id": 1
  }, /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Tfl8lXNMB-wzWbKNDFm7-102"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 38.08,
    y: 494.92,
    width: 45.7,
    height: 22.85,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 44,
      height: 1,
      paddingTop: 506,
      marginLeft: 39
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center",
      color: "#000000"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "light-dark(#000000, #ffffff)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, "1")))), _image || (_image = /*#__PURE__*/React.createElement("image", {
    x: 39,
    y: 499.5,
    width: 44,
    height: 17,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAALAAAABECAYAAAAhtL9RAAACpUlEQVR4AezcPY4UMRBA4QFiEg5CSgg5JMTEHIerkHAAcjIiTkFCihCUV7RGAhm2p13+mflW9tpq2+XqV0+r1QTz8OQHgYUJEHjh4kn9dCIwC5YmQOClyyd5AnNgaQIEXrp8I5Of424Cz1EHWVxIgMAXgnNsDgIEnqMOsriQAIEvBOfYHAQInFuHxxH+W/Sfv3uZP4q51ogAgRuBrIR5Fc+LxDHctTJ/cDc78MvRMwECn1lkzN5kBBXzTIDAZxatZ88j4MvoWiIBAufAfRphP0TXkgkQuB3gJxHqdfT30T9HL//vxqBlEiDwMbrv4vjH6OXTha8xFnmLxDHVehAg8C7Kf21+G09eRPfXNiCMaAQeQd2dzQgQuBlKgUYQIPAx6s/ieK2Xj9FiWcskQOBjdL/E8U//6LGkZRIgcCZdsdMJLCNwOgkXLEmAwEuWTdIbAQJvJIxLEiDwkmWT9EaAwBsJ45IECLxk2SS9EbiHwNtWIwLzESDwfDWR0Q4CBN4By9b5CBB4vprIaAcBAu+AZet8BAg8X02uJ6MOb0LgDpBdkUeAwHlsRe5AgMAdILsijwCB89iK3IEAgTtAdkUeAQLnsR0Z+WbuJvDNlPo6X5TA11nXm3krAueV+kcldPmy68qSx3sJEHgvsfvv/x5by5dZ/9lrYsd2bS8BAu8lZv9UBAjcuhzidSVA4K64XdaaAIFbExWvKwECd8XtstYECNyaqHhdCRC4K26XtSZwTQK3ZiPeAgQIvECRpFgnQOA6GysLECDwAkWSYp0AgetsrCxAgMALFEmKdQJtBK7Ht4JAKgECp+IVPJsAgbMJi59KgMCpeAXPJkDgbMLipxIgcCpewf9H4Og6gY8SdH4oAQIPxe/yowQIfJSg80MJEHgofpcfJfALAAD//5mb1vMAAAAGSURBVAMAF5EZiYgZRBMAAAAASUVORK5CYII="
  })))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Tfl8lXNMB-wzWbKNDFm7-103"
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 99.01,
    y: 494.92,
    width: 45.7,
    height: 22.85,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 44,
      height: 1,
      paddingTop: 506,
      marginLeft: 100
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center",
      color: "#000000"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "light-dark(#000000, #ffffff)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, "2")))), _image2 || (_image2 = /*#__PURE__*/React.createElement("image", {
    x: 100,
    y: 499.5,
    width: 44,
    height: 17,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAALAAAABECAYAAAAhtL9RAAAE/0lEQVR4AeycSagUVxSGOwMJWWQgiwSSQCATJISEEAiBkBAFERUUQRBURFFEVEQQBMUZnFBwoSKCCoIiiIK4EKeFoiCOOKEbFRQXbkRUcCFO//GprfXu7a5bt2531+tPzt9Vde69p6u/+q1XXVVd79b4B4EKE8DAFd54rHqthoFxQaUJYOBKbz5WHgPjgUoTwMCV3nztXPnOeG8M3BnbgbUoSAADFwTHsM4ggIE7YzuwFgUJYOCC4JoMM66fq8/P0p/SlxKRgICBTlC2K0t+rU89VTouPZHuSJel09Jt6b50TNogTZY+lIhIAhg4EqCGvy/Nk25Ja6W/JVd8rOQ/0iRpvXRS+k0KDgbUCWDgOosic59p0GFpsRQaZt7zGjRbek8iChDAwAWgvRzyjqabJduralI4lmqk7ZU1IUIJYOBQYvX+UzQ7XHLFKSWnSQOlftJEaY3kixVq4IueIIQGBg4l1tPf/uTP75nt9TpCmb+kddIByQ4xNmk6Xfpe2i9lw46Pl2eTLDcngIGbM3L1+E/JL6RsDFBil+SL62oYKl2QsjFOia8kIoAABg6AVau97jzm9Vx9xo6HD9UXvXOP1DJecsWvriQ5PwEM7GfTqMV1qmxrowGZtrNadu2F7cyEmoi8BDBwXlJv9/vl7cUXS0dfvOZ/sVNo2d4YOEukyTIGbgLI0fyJI2d708eOfKPUPUcjV+ccUBqlMHAjOu4215e3G+6uDbN/OFrtP4IjTcpHAAP7yPjzdiZhmJrtHPArLdJySNjZBtcFENdhRUjdrutbGQN30JZ5qnXZI+1+Q2c0nzfsCt5GT+eLnjxpDwEM7AGTMG33Pgxy1D+o3E2JCCCAgQNgRXb9SONtz7tEU1fY5eZnrgZyfgIY2M+mzBa7cndOBSdIrrALG+x9XWSa5DBwE0CRzXbGwva6R1TnJ8kVK5XcIhEFCGDgAtByDPlAfWZIVyXfXldNtVF6mSVx6CAIRSKHgYuU7eox9gXNziasFgW7y0yTXmF3qNnVvO29WkgEEcDAQbgadv5UrdukvZLvcOGB2uxGoP6aXpGISAIYOBLgy+F2/+8lzdshgSbOsGPdb9ViJueQQSDKCAwcT3GmSpyQvpFcsUPJHyQ71r2rKVEiAQwcB9N+y7bKU8J+Uv+v2kZK1yQiAQEMXByq3Yxjz3hwVZij5O+SPQdCky6NFnxsDFwMst1SudMz9H/ll0mht1dqCBFKAAOHEuvpP1qT76Rs2Ck0u2iRzbOciAAGLgZ2rGOYPS5qnyNPKiEBDBwO1/a82d/E2WOl7Kfz4dUYEUUAA4fjG+wYYqfQ5iq/MFJ21kIliLwEMHBeUvV+9sjU+lJ9boFmYzVENcqIrqmBgcM39Y/hQxiRigAGDifr2wOHV2JENAEMHIbQfs9mN+2Ejcrf+2H+rvQ0AhjYKOSX3YRjFzHMyClU5DnD+de+D/bEwH1wo3bTR8LAZW9t6rWUAAZuKW7erGwCGLhsotRrKQEM3FLcvFnZBDBw2USp11ICGLiluHmzsgn0JQOXzYZ6FSCAgSuwkVhFPwEM7GdDSwUIYOAKbCRW0U8AA/vZ0FIBAhi4AhuJVfQTKMfA/vq0QCApAQycFC/FUxPAwKkJUz8pAQycFC/FUxPAwKkJUz8pAQycFC/FmxGIbcfAsQQZ31YCGLit+HnzWAIYOJYg49tKAAO3FT9vHkvgOQAAAP//daBD2AAAAAZJREFUAwAt4XSJky0hbAAAAABJRU5ErkJggg=="
  })))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Tfl8lXNMB-wzWbKNDFm7-104"
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 159.94,
    y: 494.92,
    width: 45.7,
    height: 22.85,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 44,
      height: 1,
      paddingTop: 506,
      marginLeft: 161
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center",
      color: "#000000"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "light-dark(#000000, #ffffff)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, "3")))), _image3 || (_image3 = /*#__PURE__*/React.createElement("image", {
    x: 161,
    y: 499.5,
    width: 44,
    height: 17,
    xlinkHref: "data:image/png;base64,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"
  })))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Tfl8lXNMB-wzWbKNDFm7-105"
  }, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 220.87,
    y: 494.92,
    width: 45.7,
    height: 22.85,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 44,
      height: 1,
      paddingTop: 506,
      marginLeft: 222
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center",
      color: "#000000"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "light-dark(#000000, #ffffff)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, "4")))), _image4 || (_image4 = /*#__PURE__*/React.createElement("image", {
    x: 222,
    y: 499.5,
    width: 44,
    height: 17,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAALAAAABECAYAAAAhtL9RAAADpUlEQVR4AeycO4sUQRSFxwcigomBgpmCIIKKgWAgBuaGgmKgoCCCiQZGPkLRRBAE8ZEoig/wDxgLRqI/QEMFAw1UMBDZUzAstbVTTHdV3eqpmW+5h+6qrnur5qvD0jszvWtH/ECgYQIYuOHNY+mjEQbGBU0TwMBNbx+Lx8B4oGkCGLjp7Rty8bMxNwaejX1gFYkEMHAiONJmgwAGno19YBWJBDBwIriEtDXK2S8dGMuduz41iVQCGDiVXP+8C0r5KH0Yy53v1jmRQQADZ8DrkbpXY+9JYST9Bg6LLHIbA9vv/iZN8UIiDAhgYAOoQclbau+RCAMCGNgAqlfymM4vSoQRAQxsBFZlt0vPJMKQAAa2gbtOZZ9KmyXCkAAG7gW38+DLGnlUIowJYODygA+q5G3Jj7dquN/IOhAlCWDgkjRHI3fLEL5l9ktTnJH+S0RhAhi4LNC7KrdT8sOZ96vfwXk5Ahi4HMsTKuXMqsNyPNbZG4kwIoCBy4DdoTIPJD++qHFJIgwJNGNgQwa5pderwHPJ3f/qsByndObuf3UgrAhg4HyyV1XikOTHdTXeS4QxAQycB/iI0m9IfrxT46ZEVCCAgdMhb1HqaymM0+r4JxEVCGDgdMj3lbpV8sOZ97PfwbktAQycxves0o5LfrxS44lEVCTQwcAVV9PGVO4xoEfBUr+r7R4Z0oGoSQAD96O9UcNfSmGcVMcPiahMAAP3A+7eddg3IWWX+s5PkfuSj4asCHfP7Oed09UNEtGRAAbuCGo8LMbL/UE3TZMeK7qiun7eQ7W3SURHArEN6ZjOMAgMSwADD8t/vmev8OowcD/I3zTcfdKWIqWuCveFn7DW71Wj6IgSwMBRNBMvfFLv4UTdUV4Y7qnlsN7PcBDtOAEMHGfDlQYIYOAGNoklxglg4DgbrjRAAAM3sEkJS1yYFAy8MFs9ny8UA8/nvi7Mq8LA9bb6z4Sp/k7oo6sHAQzcA1bm0GvKd//Q2pf7IEPdRCoBDJxKjryZIICBS28D9aoSwMBVcTNZaQIYuDRR6lUlgIGr4may0gQwcGmi1KtKAANXxc1kpQnMk4FLs6FeAwQwcAObxBLjBDBwnA1XGiCAgRvYJJYYJ4CB42y40gABDNzAJrHEOIEyBo7X5woETAlgYFO8FLcmgIGtCVPflAAGNsVLcWsCGNiaMPVNCWBgU7wUn0Yg9zoGziVI/qAEMPCg+Jk8lwAGziVI/qAEMPCg+Jk8l8ASAAAA//+6OfooAAAABklEQVQDANZ6TokWpTmiAAAAAElFTkSuQmCC"
  })))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Tfl8lXNMB-wzWbKNDFm7-106"
  }, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 281.81,
    y: 494.92,
    width: 45.7,
    height: 22.85,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 44,
      height: 1,
      paddingTop: 506,
      marginLeft: 283
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center",
      color: "#000000"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "light-dark(#000000, #ffffff)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, "5")))), _image5 || (_image5 = /*#__PURE__*/React.createElement("image", {
    x: 283,
    y: 499.5,
    width: 44,
    height: 17,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAALAAAABECAYAAAAhtL9RAAAFHklEQVR4AeycSagdRRSGL4qKoIIiDiA4ouJCXYgKKoig4rQR3DiAKCK6EBQREQdURF0obgQXDgtBN4IbQVTcCM4gKAaSkEAg0yokJIsQMpD/T/Ly+tar7r5VXd33dt4XznlVdapOdefrPzd9q6vfSRP+QGDEBBDwiC8epz6ZIGBUMGoCCHjUl4+TR8BoYNQEEPCoL988T34xjo2AF+M6cBaZBBBwJjjSFoMAAl6M68BZZBJAwJngSFsMAgi423W4WOnvFPDHNAeWQQABZ0CrpNyg+isF/GnNMbMxcJkAAl5mkVO7PCeJnHIEEHA3lld0Sye7KwEE3I3g1d3Sj2fvO16jkkQAASfhWjH4+iDyotrnZPj9ysEyCCDgDGjHUs5Seaa8av+qsTPD9yoHyyCAgJOgTQ2+ZKp1tLHhaMHPoQgg4HzSl0VSN0dihHokgIDz4YYrEP9pqoNybEACCDgfdrgG/H/+VGTmEkDAueQmk3AJbV0w1clqW+Q3q7xQjvVAAAHnQ70mSF2v9n3yj+W/yw/I/aXO9W2q75b/LP9AfpUcK0BgNAIu8HctOcUZmuw8edW+VuM7+bNyf+qqmDIvud2hyAvytfJX5afJsQ4EEHAevEvz0qay3lbLX/xuUollEkDAeeBKCNhHvlI//pBfJ8cyCCDgDGhK8ZczFVH7VdGn5P5k9Re9u1V/Xv6PvM5+VIef7KnAUggg4BRay2PDNeClHgv1VjU+lf8l98qExfmR6hb0Myr3yEPz/bT3UYRx2i0EEHALoJru2C3EQxproaqImlclPlHPnfKYvabg6XIsgcAMAk6YbfUMfVh/VYvY9663qO5bhW9UzmJ/atAb8pjdFgsSqyeAgOvZNPXsUucmuVcRflPpWwUVM9u7Ghm7lbhRcSyBAAJOgFVw6H7N5dUHFVN2/lSLRisBBNyKqLcB/vQOJ/dm+DBGu4EAAm6A03NX7BaC7ZiJ0BFwIjANP1vuzTlLfoHaOeaHGGGeHzGHsfG2BzhzBJwO2f/1e3POkm/XFDmbc/w7JZQ6ZQh4Ckd7AwG3MwpH/B0G1H5QnmL3aHDsEzh1NUPTrG5DwOnX31siw6zHw0BD2/uE34v0+1GzXwiNdBGqI4CA68jUx3+JdPnT1I+PT430VUOnqPGh/Fp5aH4MHcZotxBAwC2AIt1rFNsiD+1JBX6Q+8udihXmuD+9n1vRM5l8q1jsH4bCWBMBBNxEJ953SGG/eaFihd2uiL/cbVT5pfx1+Wdy/74Ix+seFb+kMSVt1cyFgPMutVciHmhI9Sv3j6r/TfkT8tgtg8JHzFsv/erRkQY/0ggg4DRe1dF+fcjijD2QqI5rqntTkO+dm8bQ10AAATfAmaHrC43xL7mu212m7qh5W+VF6vF7dCqwXAIIOJfccp6Xvt5S81y514NfVvm53G9m+FbjJ9W/kr8vv1fuNy+8sX2r6lhHAgi4I8BK+g7VvZpgoXpFwm9meL/wXYo/Irewv1fZ5ZZD6ViVAAKu0ihRZ45BCSDgQXFzsNIEEHBposw3KAEEPChuDlaaAAIuTZT5BiWAgAfFzcFKEziRBFyaDfONgAACHsFF4hTrCSDgejb0jIAAAh7BReIU6wkg4Ho29IyAAAIewUXiFOsJlBFw/fz0QKBXAgi4V7xM3jcBBNw3YebvlQAC7hUvk/dNAAH3TZj5eyWAgHvFy+RtBLr2I+CuBMmfKwEEPFf8HLwrAQTclSD5cyWAgOeKn4N3JXAYAAD//+WBUjgAAAAGSURBVAMA8VmJiZXwFxUAAAAASUVORK5CYII="
  })))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Tfl8lXNMB-wzWbKNDFm7-107"
  }, _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 342.74,
    y: 494.92,
    width: 45.7,
    height: 22.85,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 44,
      height: 1,
      paddingTop: 506,
      marginLeft: 344
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center",
      color: "#000000"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "light-dark(#000000, #ffffff)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, "6")))), _image6 || (_image6 = /*#__PURE__*/React.createElement("image", {
    x: 344,
    y: 499.5,
    width: 44,
    height: 17,
    xlinkHref: "data:image/png;base64,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"
  })))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Tfl8lXNMB-wzWbKNDFm7-108"
  }, _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 403.67,
    y: 494.92,
    width: 45.7,
    height: 22.85,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 44,
      height: 1,
      paddingTop: 506,
      marginLeft: 405
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center",
      color: "#000000"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "light-dark(#000000, #ffffff)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, "7")))), _image7 || (_image7 = /*#__PURE__*/React.createElement("image", {
    x: 405,
    y: 499.5,
    width: 44,
    height: 17,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAALAAAABECAYAAAAhtL9RAAADsUlEQVR4AeybOasUQRSF2yVREAMxEUUwMDEwEASXwH9g5i4imggGLqCo4IIYGQkKmomCoJgYGIhi4AIumT/ARBONBdFAPRXI9Cuqne6qW91dzifnPKdu973d89VhmPfevPkV/yBQMAECXPDmcetVRYBJQdEECHDR28fNE2AyUDQBAlz09g158+O4NgEexz5wF5EECHAkONrGQYAAj2MfuItIAgQ4Ehxt4yBAgLvvwz61XMnkS5q7WEYtCRDglqBqpx3S47OZfF5zl8n/FAcnBAjwhAWPCiRAgAvcNG55QoAAT1iM5dGPsdxICfdBgLvvknsPvEltKd6m/pAOqvhVRi0JEOCWoGqnfdTjN4neqX5fF1W4LaMOBAhwB1hVZXLyfk05Itf1RIvLMupIgAB3BJZ4+nr135Hrcm8ZDqjwS0YdCRDgjsASTl+k3geyr70qfJFRBAECHAEtsuW0+tbKdd3U4pmMIgkQ4EhwHdvW6fwLsi/3jZtfY92BAAHuACvy1AXquyX7OqUCbx0EIUXFBDjlSQ7ce1jX3yLX9VmL6zJKJECAEwFOaV+u41dlXydU+C6jRAIEOBHglPaTOr5Eruu1Fg9lZECAABtAbBixQnX3kwf9N0fu1ff3nAqLaAIEOBrd1MYzgTPuqvZORkYECLARSG/MGq2Pyr7O+QXWaQRaBDjtAjPafTzwvN2r76dAnVICAQKcAK+hdanqoVffG6ojYwIE2Bioxu2Rfb1X4a2MjAkQYFug8zTumOzrml9gbUOAANtw/DvF/aWF/4Edd+yR+4LtCRBgW6a7A+PuqfZNnj318IwJsB3khRq1S/Z13y+wtiNAgO1YbtYo/9fGKlVP3RechwABtuO6PTDqsWp8aEcQcokA25HdERj1PFCjZEiAANvAXK0xK2VfL/wCa1sCBNiG54aGMR8a6rnLMzOfANts9cbAmJeq/ZRRRgIE2Abu1sCYV4EaJWMCBNgGqHsP7E/isw8+kQxrAmwDdZXGuM9B1M2vjwUltwhwbsLMz0qAAFvjZV6vBAhwr7i5mDUBAmxNlHm9EiDAveLmYtYECLA1Ueb1SoAA94qbi1kT+J8CbM2GeQUQIMAFbBK32EyAADez4UgBBAhwAZvELTYTIMDNbDhSAAECXMAmcYvNBGwC3DyfIxDISoAAZ8XL8NwECHBuwszPSoAAZ8XL8NwECHBuwszPSoAAZ8XL8GkEUo8T4FSC9A9KgAAPip+LpxIgwKkE6R+UAAEeFD8XTyXwBwAA//9ei8ZLAAAABklEQVQDAL/NWYmVGe0oAAAAAElFTkSuQmCC"
  })))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Tfl8lXNMB-wzWbKNDFm7-109"
  }, _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 464.6,
    y: 494.92,
    width: 45.7,
    height: 22.85,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 44,
      height: 1,
      paddingTop: 506,
      marginLeft: 466
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center",
      color: "#000000"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "light-dark(#000000, #ffffff)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, "8")))), _image8 || (_image8 = /*#__PURE__*/React.createElement("image", {
    x: 466,
    y: 499.5,
    width: 44,
    height: 17,
    xlinkHref: "data:image/png;base64,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"
  })))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Tfl8lXNMB-wzWbKNDFm7-112"
  }, _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 445.41,
    width: 45.7,
    height: 22.85,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 44,
      height: 1,
      paddingTop: 457,
      marginLeft: 1
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center",
      color: "#000000"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "light-dark(#000000, #ffffff)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, "A")))), _image9 || (_image9 = /*#__PURE__*/React.createElement("image", {
    x: 1,
    y: 450.5,
    width: 44,
    height: 17,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAALAAAABECAYAAAAhtL9RAAAE9UlEQVR4AeycOasVSRTH36zBbMEwGzOfYGZcUDBwAUVQAzUQ3EXcDQz9DH4FY8UFwR0TMREDRUEQ1ERFNBANTUwMBP2fZ99r33qn+nZXd997+72fnHOr61TV6X6/+tuWXX3f11P8gUCHCSDgDk8elz41hYBRQacJIOBOTx8Xj4DRQKcJIOBOT984L34yzo2AJ2MeuIpEAgg4ERzDJoMAAp6MeeAqEgkg4ERwQ4bdVvtHx3cphjVIAAE3CDNL9a/K5XLP9nhBYukEEHA6u9jInbEGxdfI/5HXMgZ/IYCAv7Bo4uhbJTksL7JtRY20VSOAgKvxGtZ7tTr8IS+yA0WNtFUjgICr8RrWu8wa9z8lWSjHGiCAgBuAmKX4VWXR+lfNfdvRP+KgFgEEXAvfwODNA7XPlSsqjslD26eArZdVYHUIIOBK9Ao7H3RaTyt2UR6arZNXhUHq1Qkg4OrMvBHzFFwiz9s7Va7LH8qfyUNjUyMkklBHwAnQnCGeGO3u+z7ra8fZYb/Yq6Of5FgNAgi4BrxsqK1l92fH+eJsruItI6x5o33g6QQQcDq73kjbXbM1ba9u5Qt93JX37IkOHslDK/PYLRxDPUcAAedgJB7aUiAcelIBe5lHRd+8ZcQ6tf4txxIJdEbAiT9f28N+0wm2ykM7FwZUvyT3bIsXJFaOAAIuxynWy3v2e0edn8tDe6nAPXlo3vo57EM9QgABR8CUDB9y+tnywQlPh85Mfw5+LFB1vhxLIICAE6BlQ0x0i7PjfHE5XwmOrwb1XpWt5R6JiiUCrggs19179ntB7W/lMXuthlvy0OwNtW/CIPXhBBDwcEZej+8UPCIPzXvSEPbJPx/utdljuJW9CmV5AiUEXD7ZHOq5Vj/rz/LQditwaojHlgveHV2psCICCLiITrwttgFhj8RMxEVuL717me1pxI9eA7E4AQQcZxNr+V0NJlQVjduGxjPO8oQIuPoEexsX1bP4I+zO7bcQdQkgYBdLYdD70uYDjThf0e+rf2jrFfhLjpUkgIBLgsq62XfZbOMhq/YLex/Cvm1cxWN3W293r3+iTh2M4GIRcDXInujsLbPH1dJM936qTxurYsDs60YDASpxAgg4ziZs+V4Bb/lwQvFU854J2+7e/6kJ59o4BFx+xu3VR+/Zr619y2cZ7Bnbdt4+2I1ajAACjpGZGff+ab+hbm/kqWZvrdl/AMPxdqdnazmk4tQRsAPFCf2p2CZ5aGW2jsMxYd1bRtjW8oqwI/WZBBDwTCZeJLZxcc3rXDFmvzvCG1Jna9nLNytjCLjctHrv/drd1746Xy5DvJe96O49E7Zz/hAfRosRQMBGodgXqdl79uu9nK6uSWZ/GbyBtrHhxYllBBBwBqKgWOa02Z33phNPDcVedF+amnCujEPAw2f6uLp8Ffgvqn+QN2WvlCg8h9WPKo4VEEDABXBomnwCCLjpOSLfSAkg4JHi5mRNE0DATRMl30gJIOCR4uZkTRNAwE0TJd9ICSDgkeLmZE0TmE0CbpoN+TpAAAF3YJK4xDgBBBxnQ0sHCCDgDkwSlxgngIDjbGjpAAEE3IFJ4hLjBJoRcDw/LRBolQACbhUvydsmgIDbJkz+Vgkg4FbxkrxtAgi4bcLkb5UAAm4VL8mHEajbjoDrEmT8WAkg4LHi5+R1CSDgugQZP1YCCHis+Dl5XQKfAAAA//+BkXmjAAAABklEQVQDAHIdZ4ndcvW+AAAAAElFTkSuQmCC"
  })))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Tfl8lXNMB-wzWbKNDFm7-114"
  }, _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 327.36,
    width: 45.7,
    height: 22.85,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 44,
      height: 1,
      paddingTop: 339,
      marginLeft: 1
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center",
      color: "#000000"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "light-dark(#000000, #ffffff)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, "C")))), _image0 || (_image0 = /*#__PURE__*/React.createElement("image", {
    x: 1,
    y: 332.5,
    width: 44,
    height: 17,
    xlinkHref: "data:image/png;base64,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"
  })))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Tfl8lXNMB-wzWbKNDFm7-115"
  }, _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 266.43,
    width: 45.7,
    height: 22.85,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 44,
      height: 1,
      paddingTop: 278,
      marginLeft: 1
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center",
      color: "#000000"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "light-dark(#000000, #ffffff)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, "D")))), _image1 || (_image1 = /*#__PURE__*/React.createElement("image", {
    x: 1,
    y: 271.5,
    width: 44,
    height: 17,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAALAAAABECAYAAAAhtL9RAAAES0lEQVR4AeycTahNURiGr58ykhgwMZKEAYWJ30iUKIkRiYGRKEYURSlkJEoZ+s1IijElTJSiKMQIYUgo+bnvV6fOae+1zlln/6y1973P7Xvbe39r7fWt+6y3275n77MnjvADgRYTwMAtXjymPjKCgXFBqwlg4FYvH5PHwHig1QQwcKuXL+Xkm1EbAzdjHZhFQQIYuCA4TmsGAQzcjHVgFgUJYOBwcBfV9X9BfdN5z6V70llphTRJIkoSwMDhAKeGd831tHMXKbtZOiI9lj5JR6UpElGQAAYuCK6C02ZqjDPSC2m1FBx07BLAwF0WqfbmqfBDaZtEDEkAAw8JLNP9jY7P9dF5td2U7kvfpX5xW41bJGIIAhh4CFiOrneVs2tanw6rfZe0Xpoh2aXCFW19YePN9TWSzxPAwHkmdWX+aOBH0l5ppfRVcsUlJSdIRAABDBwAqYYuTzTmGsl1WbFB+e0SEUAAAwdA6napdO+1RtstueKQK0kuTwAD55nEzNiNjfeOgnaJscCRJ5UhgIEzQCIf/lU9+xRDm1zsyGVI5Ahg4ByS6Inrqui6Fl6uPDGAAAYeAChC8w/VcH20tkp51kcQ+gWA+tGJ1/bOUcqen5jtyJPqIdAaA/fMeSzufvT8UtM9edIdAhi4AyLxxmfgaYnn1fjyGLgZS4SBC64DBi4IruLTPnvG++fJk+4QwMAdEIk3vofafcZOPN3mlMfAzVgLe7jdNZMvriS5LoEAA3c7s1cbgVmekX1PrHm6j780Bm7Gms93TMPuzv125En1EMDAPTAS7m501H7pyJHKEMDAGSAJDier5iYpG/YVo2yO4wwBDJwBkuDQzGu3jbOl72QTHOcJYOA8k5gZ++rQSUdB+6r9W0e+XakIs8XAESD3KWFf+FziaL/lyJFyEMDADiiRUutU55rkCtfjla5+4z6HgdNYYK3K2rsitMnFAWXstVPaEIMIYOBBhKptX6jh7J+zB9q64qmSlyUikAAGDgTl6WafINg/YT6d0nkXpBuSPbRun+1u1b4v9qnB3h+hDRFCAAOHUPL3sb+oJ9Ts03G1HZR2SnMkX9gt48VqtE8ftCkd42YADJx+qV9pCkslzCsIwwYGHpZYdf2faag90jLpg0QUIICBw6H9DO+a62mXCPZSa3tT5Wm12otL7K/uVe3/koiCBDBwOLj96mp3zorIHpe0r8nbjYtjGsfejaYNUZYABi5LkPOTEsDAVeNnvKgEMHBU3BSrmgAGrpoo40UlgIGj4qZY1QQwcNVEGS8qAQwcFTfFqiYwlgxcNRvGawEBDNyCRWKKfgIY2M+GlhYQwMAtWCSm6CeAgf1saGkBAQzcgkViin4C1RjYPz4tEKiVAAauFS+D100AA9dNmPFrJYCBa8XL4HUTwMB1E2b8Wglg4FrxMvggAmXbMXBZgpyflAAGToqf4mUJYOCyBDk/KQEMnBQ/xcsSGAUAAP//VCuscQAAAAZJREFUAwD38WuJC7jVfwAAAABJRU5ErkJggg=="
  })))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Tfl8lXNMB-wzWbKNDFm7-116"
  }, _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 205.5,
    width: 45.7,
    height: 22.85,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 44,
      height: 1,
      paddingTop: 217,
      marginLeft: 1
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center",
      color: "#000000"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "light-dark(#000000, #ffffff)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, "E")))), _image10 || (_image10 = /*#__PURE__*/React.createElement("image", {
    x: 1,
    y: 210.5,
    width: 44,
    height: 17,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAALAAAABECAYAAAAhtL9RAAACm0lEQVR4AeycsU3FQAyGH1QUsANL0CAWYANKKnZgGmagQSxAxwIUSOxAQwdOldeEnHO2YycfupMinfOf8/krnzg98AeBwgQQuPDwaP1wQGAsKE0AgUuPj+YRGAdKE0Dg0uNbs/kcdyNwjjnQxUICCLwQHK/lIIDAOeZAFwsJILAO3KWU/wbsB7mD1UAAgRsgHZWcHT17Pp57hm8pG4ELTpOWRwIIPLLgqSABBLYZ2pvEWO5PyWM1EEDgBkgzJd9yfmO8nyWP1UAAgRsgUZKXAALnnQ2dNRBA4AZIYwlP2QggcLaJ0I+KAAKrcFGcjQACZ5sI/agIILAKF8XZCCBwtonQj4pAGYFVXxVbfCHX3Rrta8lhKQggsALWP6UvcmaxXyWHpSCAwApYlOYjgMD5ZkJHCgIIrIBFaT4CCGwzkyuJsdoSxWol0CBwa9Ru64afU77L11vsD8lhKQggsAIWpfkIIHC+mdCRggACK2BRmo8AAuebCR0pCCCwAhalSgIB5QgcAJkr/AggsB9bkgMIIHAAZK7wI4DAfmxJDiCAwP2Qh98DP0mM5X6UPFYDAQRugNRQci81lvtO8nrWbt5F4N2MepsfisDbnOtuvgqBdaP+0ZUvrh5+4bb45T29iMC6aX9J+UnAHv7bpVzDmiOAwHOEOE9NAIGtx0NeKAEEDsXNZdYEENiaKHmhBBA4FDeXWRNAYGui5IUSQOBQ3FxmTWBLAluzIa8AAQQuMCRanCaAwNNsOClAAIELDIkWpwkg8DQbTgoQQOACQ6LFaQI2Ak/ncwIBVwII7IqXcG8CCOxNmHxXAgjsipdwbwII7E2YfFcCCOyKl/A5Ar3nCNxLkPdXJYDAq+Ln8l4CCNxLkPdXJYDAq+Ln8l4CfwAAAP//jrDSxwAAAAZJREFUAwA/o2+JsxUsTAAAAABJRU5ErkJggg=="
  })))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Tfl8lXNMB-wzWbKNDFm7-118"
  }, _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 83.64,
    width: 45.7,
    height: 22.85,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 44,
      height: 1,
      paddingTop: 95,
      marginLeft: 1
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center",
      color: "#000000"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "light-dark(#000000, #ffffff)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, "G")))), _image11 || (_image11 = /*#__PURE__*/React.createElement("image", {
    x: 1,
    y: 88.5,
    width: 44,
    height: 17,
    xlinkHref: "data:image/png;base64,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"
  })))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Tfl8lXNMB-wzWbKNDFm7-119"
  }, _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 22.71,
    width: 45.7,
    height: 22.85,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 44,
      height: 1,
      paddingTop: 34,
      marginLeft: 1
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center",
      color: "#000000"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "light-dark(#000000, #ffffff)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, "H")))), _image12 || (_image12 = /*#__PURE__*/React.createElement("image", {
    x: 1,
    y: 27.5,
    width: 44,
    height: 17,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAALAAAABECAYAAAAhtL9RAAACoElEQVR4AeyaO07EQAxAFxoqKBENR6DhDvRchB6JS3AQxAE4DwXUSEjQgFfaVaJoZ5P52LGThybayXxs5/mVnG74g0BgAggcuHmUvtkgMBaEJoDAodtH8QiMA6EJIHDo9s1ZvI/cCOyjD1RRSACBC8FxzQcBBPbRB6ooJIDA08G9yNG/wfMg77XjSgIM427fL2WdMUIAgUcA9bYvevP99Hw/qfg9S9xNrSeOr3MZgQP2nZI7AgjcsWAWkAACB2waJXcEELhjwSwgAQQO2DRK7gggcMeCWUACCJzVNA57I4DA3jpCPVkEEDgLF4e9EUBgbx2hniwCCJyFi8PeCCCwt45QTxaBMAJnfZXd4UdJ9Vb5vMp9RiEBBC4Et7u2/W+0O5nXPLdyn1FIAIELwXHNBwEE9tEHqigkgMCF4HrX3mVe83zJfUYhAQQuBLe79iS/15XPjdxnFBKYIHBhZK5BwIAAAhtAJoUeAQTWY0tkAwIIbACZFHoEEFiPLZENCCCwAeTVpjD4cAQ2gEwKPQIIrMeWyAYEENgAMin0CCCwHlsiGxBAYAPIpNAjgMB6bOeMvJrcCLyaVi/zQxF4mX1dzVch8PRWfx84emjtwLGjSz+J3d/EOss9AgjcgzEyvZf9k8HzLO+140MCDONu3z9lnTFCAIFHALHtmwACt+4P8UwJILApbpK1JoDArYkSz5QAApviJllrAgjcmijxTAkgsClukrUmsCSBW7MhXgACCBygSZSYJoDAaTbsBCCAwAGaRIlpAgicZsNOAAIIHKBJlJgm0EbgdHx2IKBKAIFV8RJcmwACaxMmvioBBFbFS3BtAgisTZj4qgQQWBUvwccI1O4jcC1B7s9KAIFnxU/yWgIIXEuQ+7MSQOBZ8ZO8lsA/AAAA//9yKZaBAAAABklEQVQDAD1QNIn30a3RAAAAAElFTkSuQmCC"
  })))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Tfl8lXNMB-wzWbKNDFm7-21"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 213.26,
    y: -0.14,
    width: 60.93,
    height: 60.93,
    fill: "#cdeb8b",
    stroke: "#36393d",
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(205, 235, 139), rgb(32, 58, 0))",
      stroke: "light-dark(rgb(54, 57, 61), rgb(186, 189, 192))"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Tfl8lXNMB-wzWbKNDFm7-22"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 274.19,
    y: -0.14,
    width: 60.93,
    height: 60.93,
    fill: "#cdeb8b",
    stroke: "#36393d",
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(205, 235, 139), rgb(32, 58, 0))",
      stroke: "light-dark(rgb(54, 57, 61), rgb(186, 189, 192))"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Tfl8lXNMB-wzWbKNDFm7-23"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 335.12,
    y: -0.14,
    width: 60.93,
    height: 60.93,
    fill: "#cdeb8b",
    stroke: "#36393d",
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(205, 235, 139), rgb(32, 58, 0))",
      stroke: "light-dark(rgb(54, 57, 61), rgb(186, 189, 192))"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Tfl8lXNMB-wzWbKNDFm7-24"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 396.05,
    y: -0.14,
    width: 60.93,
    height: 60.93,
    fill: "#cdeb8b",
    stroke: "#36393d",
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(205, 235, 139), rgb(32, 58, 0))",
      stroke: "light-dark(rgb(54, 57, 61), rgb(186, 189, 192))"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Tfl8lXNMB-wzWbKNDFm7-25"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 456.98,
    y: -0.14,
    width: 60.93,
    height: 60.93,
    fill: "#cdeb8b",
    stroke: "#36393d",
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(205, 235, 139), rgb(32, 58, 0))",
      stroke: "light-dark(rgb(54, 57, 61), rgb(186, 189, 192))"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Tfl8lXNMB-wzWbKNDFm7-27"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 152.33,
    y: -0.14,
    width: 60.93,
    height: 60.93,
    fill: "#cdeb8b",
    stroke: "#36393d",
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(205, 235, 139), rgb(32, 58, 0))",
      stroke: "light-dark(rgb(54, 57, 61), rgb(186, 189, 192))"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Tfl8lXNMB-wzWbKNDFm7-29"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 30.47,
    y: -0.14,
    width: 60.93,
    height: 60.93,
    fill: "#cdeb8b",
    stroke: "#36393d",
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(205, 235, 139), rgb(32, 58, 0))",
      stroke: "light-dark(rgb(54, 57, 61), rgb(186, 189, 192))"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Tfl8lXNMB-wzWbKNDFm7-31"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 213.26,
    y: 60.79,
    width: 60.93,
    height: 60.93,
    fill: "#cdeb8b",
    stroke: "#36393d",
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(205, 235, 139), rgb(32, 58, 0))",
      stroke: "light-dark(rgb(54, 57, 61), rgb(186, 189, 192))"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Tfl8lXNMB-wzWbKNDFm7-32"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 274.19,
    y: 60.79,
    width: 60.93,
    height: 60.93,
    fill: "#cdeb8b",
    stroke: "#36393d",
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(205, 235, 139), rgb(32, 58, 0))",
      stroke: "light-dark(rgb(54, 57, 61), rgb(186, 189, 192))"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Tfl8lXNMB-wzWbKNDFm7-33"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 335.12,
    y: 60.79,
    width: 60.93,
    height: 60.93,
    fill: "#cdeb8b",
    stroke: "#36393d",
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(205, 235, 139), rgb(32, 58, 0))",
      stroke: "light-dark(rgb(54, 57, 61), rgb(186, 189, 192))"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Tfl8lXNMB-wzWbKNDFm7-34"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 396.05,
    y: 60.79,
    width: 60.93,
    height: 60.93,
    fill: "#cdeb8b",
    stroke: "#36393d",
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(205, 235, 139), rgb(32, 58, 0))",
      stroke: "light-dark(rgb(54, 57, 61), rgb(186, 189, 192))"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Tfl8lXNMB-wzWbKNDFm7-35"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 456.98,
    y: 60.79,
    width: 60.93,
    height: 60.93,
    fill: "#cdeb8b",
    stroke: "#36393d",
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(205, 235, 139), rgb(32, 58, 0))",
      stroke: "light-dark(rgb(54, 57, 61), rgb(186, 189, 192))"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Tfl8lXNMB-wzWbKNDFm7-37"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 152.33,
    y: 60.79,
    width: 60.93,
    height: 60.93,
    fill: "#cdeb8b",
    stroke: "#36393d",
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(205, 235, 139), rgb(32, 58, 0))",
      stroke: "light-dark(rgb(54, 57, 61), rgb(186, 189, 192))"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Tfl8lXNMB-wzWbKNDFm7-38"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 91.4,
    y: 60.79,
    width: 60.93,
    height: 60.93,
    fill: "#ffcccc",
    stroke: "none",
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(255, 204, 204), rgb(87, 43, 43))"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Tfl8lXNMB-wzWbKNDFm7-39"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 30.47,
    y: 60.79,
    width: 60.93,
    height: 60.93,
    fill: "#cdeb8b",
    stroke: "#36393d",
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(205, 235, 139), rgb(32, 58, 0))",
      stroke: "light-dark(rgb(54, 57, 61), rgb(186, 189, 192))"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Tfl8lXNMB-wzWbKNDFm7-41"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 213.26,
    y: 121.72,
    width: 60.93,
    height: 60.93,
    fill: "#cdeb8b",
    stroke: "#36393d",
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(205, 235, 139), rgb(32, 58, 0))",
      stroke: "light-dark(rgb(54, 57, 61), rgb(186, 189, 192))"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Tfl8lXNMB-wzWbKNDFm7-42"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 274.19,
    y: 121.72,
    width: 60.93,
    height: 60.93,
    fill: "#cdeb8b",
    stroke: "#36393d",
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(205, 235, 139), rgb(32, 58, 0))",
      stroke: "light-dark(rgb(54, 57, 61), rgb(186, 189, 192))"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Tfl8lXNMB-wzWbKNDFm7-43"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 335.12,
    y: 121.72,
    width: 60.93,
    height: 60.93,
    fill: "#cdeb8b",
    stroke: "#36393d",
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(205, 235, 139), rgb(32, 58, 0))",
      stroke: "light-dark(rgb(54, 57, 61), rgb(186, 189, 192))"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Tfl8lXNMB-wzWbKNDFm7-44"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 396.05,
    y: 121.72,
    width: 60.93,
    height: 60.93,
    fill: "#cdeb8b",
    stroke: "#36393d",
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(205, 235, 139), rgb(32, 58, 0))",
      stroke: "light-dark(rgb(54, 57, 61), rgb(186, 189, 192))"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Tfl8lXNMB-wzWbKNDFm7-45"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 456.98,
    y: 121.72,
    width: 60.93,
    height: 60.93,
    fill: "#cdeb8b",
    stroke: "#36393d",
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(205, 235, 139), rgb(32, 58, 0))",
      stroke: "light-dark(rgb(54, 57, 61), rgb(186, 189, 192))"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Tfl8lXNMB-wzWbKNDFm7-47"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 152.33,
    y: 121.72,
    width: 60.93,
    height: 60.93,
    fill: "#cdeb8b",
    stroke: "#36393d",
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(205, 235, 139), rgb(32, 58, 0))",
      stroke: "light-dark(rgb(54, 57, 61), rgb(186, 189, 192))"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Tfl8lXNMB-wzWbKNDFm7-48"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 91.4,
    y: 121.72,
    width: 60.93,
    height: 60.93,
    fill: "#cdeb8b",
    stroke: "#36393d",
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(205, 235, 139), rgb(32, 58, 0))",
      stroke: "light-dark(rgb(54, 57, 61), rgb(186, 189, 192))"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Tfl8lXNMB-wzWbKNDFm7-49"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 30.47,
    y: 121.72,
    width: 60.93,
    height: 60.93,
    fill: "#cdeb8b",
    stroke: "#36393d",
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(205, 235, 139), rgb(32, 58, 0))",
      stroke: "light-dark(rgb(54, 57, 61), rgb(186, 189, 192))"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Tfl8lXNMB-wzWbKNDFm7-51"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 213.26,
    y: 182.65,
    width: 60.93,
    height: 60.93,
    fill: "#cdeb8b",
    stroke: "#36393d",
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(205, 235, 139), rgb(32, 58, 0))",
      stroke: "light-dark(rgb(54, 57, 61), rgb(186, 189, 192))"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Tfl8lXNMB-wzWbKNDFm7-52"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 274.19,
    y: 182.65,
    width: 60.93,
    height: 60.93,
    fill: "#cdeb8b",
    stroke: "#36393d",
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(205, 235, 139), rgb(32, 58, 0))",
      stroke: "light-dark(rgb(54, 57, 61), rgb(186, 189, 192))"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Tfl8lXNMB-wzWbKNDFm7-53"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 335.12,
    y: 182.65,
    width: 60.93,
    height: 60.93,
    fill: "#cdeb8b",
    stroke: "#36393d",
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(205, 235, 139), rgb(32, 58, 0))",
      stroke: "light-dark(rgb(54, 57, 61), rgb(186, 189, 192))"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Tfl8lXNMB-wzWbKNDFm7-54"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 396.05,
    y: 182.65,
    width: 60.93,
    height: 60.93,
    fill: "#cdeb8b",
    stroke: "#36393d",
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(205, 235, 139), rgb(32, 58, 0))",
      stroke: "light-dark(rgb(54, 57, 61), rgb(186, 189, 192))"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Tfl8lXNMB-wzWbKNDFm7-55"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 456.98,
    y: 182.65,
    width: 60.93,
    height: 60.93,
    fill: "#cdeb8b",
    stroke: "#36393d",
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(205, 235, 139), rgb(32, 58, 0))",
      stroke: "light-dark(rgb(54, 57, 61), rgb(186, 189, 192))"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Tfl8lXNMB-wzWbKNDFm7-57"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 152.33,
    y: 182.65,
    width: 60.93,
    height: 60.93,
    fill: "#cdeb8b",
    stroke: "#36393d",
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(205, 235, 139), rgb(32, 58, 0))",
      stroke: "light-dark(rgb(54, 57, 61), rgb(186, 189, 192))"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Tfl8lXNMB-wzWbKNDFm7-58"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 91.4,
    y: 182.65,
    width: 60.93,
    height: 60.93,
    fill: "#cdeb8b",
    stroke: "#36393d",
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(205, 235, 139), rgb(32, 58, 0))",
      stroke: "light-dark(rgb(54, 57, 61), rgb(186, 189, 192))"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Tfl8lXNMB-wzWbKNDFm7-59"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 30.47,
    y: 182.65,
    width: 60.93,
    height: 60.93,
    fill: "#cdeb8b",
    stroke: "#36393d",
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(205, 235, 139), rgb(32, 58, 0))",
      stroke: "light-dark(rgb(54, 57, 61), rgb(186, 189, 192))"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Tfl8lXNMB-wzWbKNDFm7-61"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 213.26,
    y: 243.58,
    width: 60.93,
    height: 60.93,
    fill: "#cdeb8b",
    stroke: "#36393d",
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(205, 235, 139), rgb(32, 58, 0))",
      stroke: "light-dark(rgb(54, 57, 61), rgb(186, 189, 192))"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Tfl8lXNMB-wzWbKNDFm7-62"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 274.19,
    y: 243.58,
    width: 60.93,
    height: 60.93,
    fill: "#cdeb8b",
    stroke: "#36393d",
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(205, 235, 139), rgb(32, 58, 0))",
      stroke: "light-dark(rgb(54, 57, 61), rgb(186, 189, 192))"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Tfl8lXNMB-wzWbKNDFm7-63"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 335.12,
    y: 243.58,
    width: 60.93,
    height: 60.93,
    fill: "#ffcccc",
    stroke: "#36393d",
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(255, 204, 204), rgb(87, 43, 43))",
      stroke: "light-dark(rgb(54, 57, 61), rgb(186, 189, 192))"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Tfl8lXNMB-wzWbKNDFm7-64"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 396.05,
    y: 243.58,
    width: 60.93,
    height: 60.93,
    fill: "#ffcccc",
    stroke: "#36393d",
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(255, 204, 204), rgb(87, 43, 43))",
      stroke: "light-dark(rgb(54, 57, 61), rgb(186, 189, 192))"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Tfl8lXNMB-wzWbKNDFm7-65"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 456.98,
    y: 243.58,
    width: 60.93,
    height: 60.93,
    fill: "#ffcccc",
    stroke: "#36393d",
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(255, 204, 204), rgb(87, 43, 43))",
      stroke: "light-dark(rgb(54, 57, 61), rgb(186, 189, 192))"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Tfl8lXNMB-wzWbKNDFm7-67"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 152.33,
    y: 243.58,
    width: 60.93,
    height: 60.93,
    fill: "#cdeb8b",
    stroke: "#36393d",
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(205, 235, 139), rgb(32, 58, 0))",
      stroke: "light-dark(rgb(54, 57, 61), rgb(186, 189, 192))"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Tfl8lXNMB-wzWbKNDFm7-68"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 91.4,
    y: 243.58,
    width: 60.93,
    height: 60.93,
    fill: "#cdeb8b",
    stroke: "#36393d",
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(205, 235, 139), rgb(32, 58, 0))",
      stroke: "light-dark(rgb(54, 57, 61), rgb(186, 189, 192))"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Tfl8lXNMB-wzWbKNDFm7-69"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 30.47,
    y: 243.58,
    width: 60.93,
    height: 60.93,
    fill: "#cdeb8b",
    stroke: "#36393d",
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(205, 235, 139), rgb(32, 58, 0))",
      stroke: "light-dark(rgb(54, 57, 61), rgb(186, 189, 192))"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Tfl8lXNMB-wzWbKNDFm7-71"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 213.26,
    y: 304.51,
    width: 60.93,
    height: 60.93,
    fill: "#ffcc99",
    stroke: "#36393d",
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(255, 204, 153), rgb(94, 50, 6))",
      stroke: "light-dark(rgb(54, 57, 61), rgb(186, 189, 192))"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Tfl8lXNMB-wzWbKNDFm7-72"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 274.19,
    y: 304.51,
    width: 60.93,
    height: 60.93,
    fill: "#ffcc99",
    stroke: "#36393d",
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(255, 204, 153), rgb(94, 50, 6))",
      stroke: "light-dark(rgb(54, 57, 61), rgb(186, 189, 192))"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Tfl8lXNMB-wzWbKNDFm7-73"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 335.12,
    y: 304.51,
    width: 60.93,
    height: 60.93,
    fill: "#ffcccc",
    stroke: "#36393d",
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(255, 204, 204), rgb(87, 43, 43))",
      stroke: "light-dark(rgb(54, 57, 61), rgb(186, 189, 192))"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Tfl8lXNMB-wzWbKNDFm7-74"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 396.05,
    y: 304.51,
    width: 60.93,
    height: 60.93,
    fill: "#ffcccc",
    stroke: "#36393d",
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(255, 204, 204), rgb(87, 43, 43))",
      stroke: "light-dark(rgb(54, 57, 61), rgb(186, 189, 192))"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Tfl8lXNMB-wzWbKNDFm7-75"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 456.98,
    y: 304.51,
    width: 60.93,
    height: 60.93,
    fill: "#ffcccc",
    stroke: "#36393d",
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(255, 204, 204), rgb(87, 43, 43))",
      stroke: "light-dark(rgb(54, 57, 61), rgb(186, 189, 192))"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Tfl8lXNMB-wzWbKNDFm7-77"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 152.33,
    y: 304.51,
    width: 60.93,
    height: 60.93,
    fill: "#cdeb8b",
    stroke: "#36393d",
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(205, 235, 139), rgb(32, 58, 0))",
      stroke: "light-dark(rgb(54, 57, 61), rgb(186, 189, 192))"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Tfl8lXNMB-wzWbKNDFm7-78"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 91.4,
    y: 304.51,
    width: 60.93,
    height: 60.93,
    fill: "#cdeb8b",
    stroke: "#36393d",
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(205, 235, 139), rgb(32, 58, 0))",
      stroke: "light-dark(rgb(54, 57, 61), rgb(186, 189, 192))"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Tfl8lXNMB-wzWbKNDFm7-79"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 30.47,
    y: 304.51,
    width: 60.93,
    height: 60.93,
    fill: "#cdeb8b",
    stroke: "#36393d",
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(205, 235, 139), rgb(32, 58, 0))",
      stroke: "light-dark(rgb(54, 57, 61), rgb(186, 189, 192))"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Tfl8lXNMB-wzWbKNDFm7-81"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 213.26,
    y: 365.44,
    width: 60.93,
    height: 60.93,
    fill: "#ffcc99",
    stroke: "#36393d",
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(255, 204, 153), rgb(94, 50, 6))",
      stroke: "light-dark(rgb(54, 57, 61), rgb(186, 189, 192))"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Tfl8lXNMB-wzWbKNDFm7-82"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 274.19,
    y: 365.44,
    width: 60.93,
    height: 60.93,
    fill: "#ffcc99",
    stroke: "#36393d",
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(255, 204, 153), rgb(94, 50, 6))",
      stroke: "light-dark(rgb(54, 57, 61), rgb(186, 189, 192))"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Tfl8lXNMB-wzWbKNDFm7-83"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 335.12,
    y: 365.44,
    width: 60.93,
    height: 60.93,
    fill: "#ffcc99",
    stroke: "#36393d",
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(255, 204, 153), rgb(94, 50, 6))",
      stroke: "light-dark(rgb(54, 57, 61), rgb(186, 189, 192))"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Tfl8lXNMB-wzWbKNDFm7-84"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 396.05,
    y: 365.44,
    width: 60.93,
    height: 60.93,
    fill: "#ffcccc",
    stroke: "#36393d",
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(255, 204, 204), rgb(87, 43, 43))",
      stroke: "light-dark(rgb(54, 57, 61), rgb(186, 189, 192))"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Tfl8lXNMB-wzWbKNDFm7-85"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 456.98,
    y: 365.44,
    width: 60.93,
    height: 60.93,
    fill: "#ffcccc",
    stroke: "#36393d",
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(255, 204, 204), rgb(87, 43, 43))",
      stroke: "light-dark(rgb(54, 57, 61), rgb(186, 189, 192))"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Tfl8lXNMB-wzWbKNDFm7-87"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 152.33,
    y: 365.44,
    width: 60.93,
    height: 60.93,
    fill: "#ffcc99",
    stroke: "#36393d",
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(255, 204, 153), rgb(94, 50, 6))",
      stroke: "light-dark(rgb(54, 57, 61), rgb(186, 189, 192))"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Tfl8lXNMB-wzWbKNDFm7-88"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 91.4,
    y: 365.44,
    width: 60.93,
    height: 60.93,
    fill: "#ffcc99",
    stroke: "#36393d",
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(255, 204, 153), rgb(94, 50, 6))",
      stroke: "light-dark(rgb(54, 57, 61), rgb(186, 189, 192))"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Tfl8lXNMB-wzWbKNDFm7-89"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 30.47,
    y: 365.44,
    width: 60.93,
    height: 60.93,
    fill: "#cdeb8b",
    stroke: "#36393d",
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(205, 235, 139), rgb(32, 58, 0))",
      stroke: "light-dark(rgb(54, 57, 61), rgb(186, 189, 192))"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Tfl8lXNMB-wzWbKNDFm7-91"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 213.26,
    y: 426.37,
    width: 60.93,
    height: 60.93,
    fill: "#ffcc99",
    stroke: "#36393d",
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(255, 204, 153), rgb(94, 50, 6))",
      stroke: "light-dark(rgb(54, 57, 61), rgb(186, 189, 192))"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Tfl8lXNMB-wzWbKNDFm7-92"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 274.19,
    y: 426.37,
    width: 60.93,
    height: 60.93,
    fill: "#ffcc99",
    stroke: "#36393d",
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(255, 204, 153), rgb(94, 50, 6))",
      stroke: "light-dark(rgb(54, 57, 61), rgb(186, 189, 192))"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Tfl8lXNMB-wzWbKNDFm7-93"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 335.12,
    y: 426.37,
    width: 60.93,
    height: 60.93,
    fill: "#ffcc99",
    stroke: "#36393d",
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(255, 204, 153), rgb(94, 50, 6))",
      stroke: "light-dark(rgb(54, 57, 61), rgb(186, 189, 192))"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Tfl8lXNMB-wzWbKNDFm7-94"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 396.05,
    y: 426.37,
    width: 60.93,
    height: 60.93,
    fill: "#ffcccc",
    stroke: "#36393d",
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(255, 204, 204), rgb(87, 43, 43))",
      stroke: "light-dark(rgb(54, 57, 61), rgb(186, 189, 192))"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Tfl8lXNMB-wzWbKNDFm7-95"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 456.98,
    y: 426.37,
    width: 60.93,
    height: 60.93,
    fill: "#ffcccc",
    stroke: "#36393d",
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(255, 204, 204), rgb(87, 43, 43))",
      stroke: "light-dark(rgb(54, 57, 61), rgb(186, 189, 192))"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Tfl8lXNMB-wzWbKNDFm7-97"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 152.33,
    y: 426.37,
    width: 60.93,
    height: 60.93,
    fill: "#ffcc99",
    stroke: "#36393d",
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(255, 204, 153), rgb(94, 50, 6))",
      stroke: "light-dark(rgb(54, 57, 61), rgb(186, 189, 192))"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Tfl8lXNMB-wzWbKNDFm7-98"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 91.4,
    y: 426.37,
    width: 60.93,
    height: 60.93,
    fill: "#ffcc99",
    stroke: "#36393d",
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(255, 204, 153), rgb(94, 50, 6))",
      stroke: "light-dark(rgb(54, 57, 61), rgb(186, 189, 192))"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Tfl8lXNMB-wzWbKNDFm7-99"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 30.47,
    y: 426.37,
    width: 60.93,
    height: 60.93,
    fill: "#ffcc99",
    stroke: "#36393d",
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(255, 204, 153), rgb(94, 50, 6))",
      stroke: "light-dark(rgb(54, 57, 61), rgb(186, 189, 192))"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Tfl8lXNMB-wzWbKNDFm7-113"
  }, _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 384.48,
    width: 45.7,
    height: 22.85,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 44,
      height: 1,
      paddingTop: 396,
      marginLeft: 1
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center",
      color: "#000000"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "light-dark(#000000, #ffffff)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, "B")))), _image13 || (_image13 = /*#__PURE__*/React.createElement("image", {
    x: 1,
    y: 389.5,
    width: 44,
    height: 17,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAALAAAABECAYAAAAhtL9RAAAElElEQVR4AeybS8gOURjHP6RQlBQll4gtUkhZiZ1cNjZuC9lIFiyRS7J0SVKyYSGSUCylXHJZYeWydCmSS1iQ2//p6+v73nnPmTlzOTPv8NPzd2ae88w54zf/xrxzGd7HHwi0mAAGbvHBY9f7+jAwLmg1AQzc6sPHzmNgPNBqAhi41YevyZ3vjbkxcG8cB/aiIAEMXBAcm/UGAQzcG8eBvShIAAPnA3dB5X9K6K22fSxdkbZKsySiBAEMnA/e2HzlXdUTlZkjrZJOSC+ks9JkiShAAAMXgFbxJhs03lPJjK0mO6gYJICBB1k0uWRn9jvagWkSkYMABs4By1N6WfltKdqpvgPScem+5Asz8W5fJ3k3AQzs5pIne0nFdj3r02H175W2S4ulCdJ1yRVblJwuEYEEMHAgqArLPmis1dJRyRVLXUlybgIY2M0ldvanJvBdLsxWHxFIAAMHguovq/TvbxrtrpSMGckE634CGNjPpo4euw+cnMeMncyx7iGAgT1gakrPd8xj94QdaVIuAhjYRaWe3DhN43p48Ux5IpAABg4EVXHZaI1nj5DVdMQXrd2SiEACGDgQVIVlUzTWNcneh1DTEXav+HNHhpVUAq0xcOq/otnOlZreHkD4ZG+d7VHNMemh9FJy3eu1hxuus7LKCR8BDOwjE55fq9JTKbIndPYo2c6uC1TniiNKrpF+S0QOAhg4B6yIpc819kiJyEkAA+cEFqn8pMa1uw8L1RI5CGDgHLBSSl+pL012d0ElqWE/7h6oYolEBBLAwIGgUsrWq29qhuyer7Eerzr7AXdQrc/UZ9Rnt9nUEFkEDGpGDd0VEbBv6T5prJuS3ZWw1yYvajkZM5XwveijLmIoAQw8lEa9yx81nZ29b6tNxsZkgnU3AQzs5lJX9ocmspfd1XSEXQ/bZUdHkpVuAhi4m0ndGd+jY94LDjgSGDgAUuSSXxrf9YOO94IFJiswcBah+P2jNIV90KmmI953rLVxpYZ9xsA1QM6YYpGn357OebpIDxDAwAMkmmt3Oaa2S4o3jjypBAEMnABS4+oYzXVaWi4l43wywbqbAAZ2c4mZHaHB50r3pM2SK/a7kuS6CWDgbiZ5M5u0wb4A2dnW3ge2T+ofqd71OZHSffbq5WtbQNkEMHA2o6wKuwSwhxFZsrOt733ggTmuauGQVDb+m+0xcO8c6nPaFXs5/rtaIpAABg4EFbHsicZeJq2T7NGyGiKUAAYOJdVf97W/Kfz3O21phrXv33Zo2X7MzVN7QyIKEMDA+aDZf/HDtElRTdK2ZtoVau07ODOzvWapVaIIAQxchBrb9AwBDFz1oWC8Wglg4FpxM1nVBDBw1UQZr1YCGLhW3ExWNQEMXDVRxquVAAauFTeTVU3gXzJw1WwYrwUEMHALDhK76CeAgf1s6GkBAQzcgoPELvoJYGA/G3paQAADt+AgsYt+AtUY2D8+PRCISgADR8XL4LEJYODYhBk/KgEMHBUvg8cmgIFjE2b8qAQwcFS8DJ5FoGw/Bi5LkO0bJYCBG8XP5GUJYOCyBNm+UQIYuFH8TF6WwF8AAAD//wghGjsAAAAGSURBVAMA57aEifeS9oYAAAAASUVORK5CYII="
  })))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Tfl8lXNMB-wzWbKNDFm7-117"
  }, _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 140.76,
    width: 45.7,
    height: 22.85,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 44,
      height: 1,
      paddingTop: 152,
      marginLeft: 1
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center",
      color: "#000000"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "light-dark(#000000, #ffffff)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, "F")))), _image14 || (_image14 = /*#__PURE__*/React.createElement("image", {
    x: 1,
    y: 145.5,
    width: 44,
    height: 17,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAALAAAABECAYAAAAhtL9RAAACjElEQVR4AeySvU3GQAxAAxIlJSU1S9DQQccKDMACjMAqVDRQUMMQIDoWoKGgAXefhBJxztmOnTx0J30k/svz2x/4g0BhAghceHmMPgwIjAWlCSBw6fUxPALjQGkCCFx6fUsOn6M3AufYA1PMJIDAM8GRloMAAufYA1PMJIDA88C9S9qP472W2pwGAgjcAGkk5GjkmeWjQ8tia66FwAW3y8g7Agi8Y8GvggQQ2G5pH1Lq2ei+SR1OAwEEboDUGHIlcadG907qcBoIIHADJELyEkDgvLthsgYCCNwAaRfCr2wEEDjbRphHRQCBVbgIzkYAgbNthHlUBBBYhYvgbAQQONtGmEdFoIzAqq9aJvhM2l503HPJPZDLURBAYAWsf0Jv5P1Dx32U3BO5HAUBBFbAIjQfAQTOtxMmUhBAYAUsQvMRQGC7ndxKqcvO+yr5HAWBBoEV1bYd+iSff995vyWfoyCAwApYhOYjgMD5dsJECgIIrIBFaD4CCJxvJ0ykIIDACliEKgkEhCNwAGRa+BFAYD+2VA4ggMABkGnhRwCB/dhSOYAAAgdApoUfAQT2Y7tk5c30RuDNrHqdH4rA69zrZr4Kgeet+nMk7WvkGY+cCSDwPMDHkrb3577I/5xgAggcDJx2tgQQ2JbnMFAvlAACh+KmmTUBBLYmSr1QAggciptm1gQQ2Joo9UIJIHAobppZE1iTwNZsqFeAAAIXWBIjThNA4Gk2vClAAIELLIkRpwkg8DQb3hQggMAFlsSI0wRsBJ6uzxsIuBJAYFe8FPcmgMDehKnvSgCBXfFS3JsAAnsTpr4rAQR2xUvx/wj0vkfgXoLkL0oAgRfFT/NeAgjcS5D8RQkg8KL4ad5L4BcAAP//tW+dnQAAAAZJREFUAwABXlSJIk+sZQAAAABJRU5ErkJggg=="
  })))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Tfl8lXNMB-wzWbKNDFm7-125"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 97.6,
    height: 70.07,
    viewBox: "119 138.5491485595703 156.4444580078125 112.45085144042969",
    fill: "none",
    x: 403.67,
    y: 395.91,
    style: {
      fontFamily: "initial"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, "&#xa;", _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M120 180C120 180 135 155 160 145C185 135 210 140 230 150C250 160 270 180 270 180C270 180 280 200 270 220C260 240 230 250 200 250C170 250 140 240 130 220C120 200 120 180 120 180Z",
    fill: "#A0A0A0",
    stroke: "#707070",
    strokeWidth: 2
  })), "&#xa;")))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Tfl8lXNMB-wzWbKNDFm7-126"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 129.48,
    height: 92.96,
    viewBox: "119 138.5491485595703 156.4444580078125 112.45085144042969",
    fill: "none",
    x: 357.97,
    y: 257.25,
    style: {
      fontFamily: "initial"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, "&#xa;", _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M120 180C120 180 135 155 160 145C185 135 210 140 230 150C250 160 270 180 270 180C270 180 280 200 270 220C260 240 230 250 200 250C170 250 140 240 130 220C120 200 120 180 120 180Z",
    fill: "#A0A0A0",
    stroke: "#707070",
    strokeWidth: 2
  })), "&#xa;")))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Tfl8lXNMB-wzWbKNDFm7-127"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42.33,
    height: 30.39,
    viewBox: "119 138.5491485595703 156.4444580078125 112.45085144042969",
    fill: "none",
    x: 100.7,
    y: 79.87,
    style: {
      fontFamily: "initial"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, "&#xa;", _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M120 180C120 180 135 155 160 145C185 135 210 140 230 150C250 160 270 180 270 180C270 180 280 200 270 220C260 240 230 250 200 250C170 250 140 240 130 220C120 200 120 180 120 180Z",
    fill: "#A0A0A0",
    stroke: "#707070",
    strokeWidth: 2
  })), "&#xa;")))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Tfl8lXNMB-wzWbKNDFm7-131"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 281.8,
    height: 66,
    viewBox: "28 48 444 104",
    x: 38.08,
    y: 261.86,
    style: {
      fontFamily: "initial"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, "&#xa;  ", _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, "&#xa;    ", /*#__PURE__*/React.createElement("marker", {
    id: "arrowhead",
    viewBox: "0 0 10 10",
    refX: 8,
    refY: 5,
    markerWidth: 6,
    markerHeight: 6,
    orient: "auto"
  }, "&#xa;      ", /*#__PURE__*/React.createElement("path", {
    d: "M 0 2 L 10 5 L 0 8 Z",
    fill: "#4A90E2"
  }), "&#xa;    "), "&#xa;  ")), "&#xa;&#xa;  ", _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#4A90E2",
    strokeWidth: 4,
    strokeLinecap: "round",
    markerEnd: "url(#arrowhead)"
  }, "&#xa;    ", /*#__PURE__*/React.createElement("path", {
    d: "M 50 60 Q 100 40 150 60 T 250 60 T 350 60 T 450 60"
  }), "&#xa;    &#xa;    ", /*#__PURE__*/React.createElement("path", {
    d: "M 30 100 Q 80 80 130 100 T 230 100 T 330 100 T 430 100"
  }), "&#xa;    &#xa;    ", /*#__PURE__*/React.createElement("path", {
    d: "M 70 140 Q 120 120 170 140 T 270 140 T 370 140 T 470 140"
  }), "&#xa;  ")), "&#xa;")))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Tfl8lXNMB-wzWbKNDFm7-132"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 342.73,
    height: 80.27,
    viewBox: "28 48 444 104",
    x: 45.7,
    y: 373.72,
    style: {
      fontFamily: "initial"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, "&#xa;  ", _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, "&#xa;    ", /*#__PURE__*/React.createElement("marker", {
    id: "arrowhead",
    viewBox: "0 0 10 10",
    refX: 8,
    refY: 5,
    markerWidth: 6,
    markerHeight: 6,
    orient: "auto"
  }, "&#xa;      ", /*#__PURE__*/React.createElement("path", {
    d: "M 0 2 L 10 5 L 0 8 Z",
    fill: "#4A90E2"
  }), "&#xa;    "), "&#xa;  ")), "&#xa;&#xa;  ", _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#4A90E2",
    strokeWidth: 4,
    strokeLinecap: "round",
    markerEnd: "url(#arrowhead)"
  }, "&#xa;    ", /*#__PURE__*/React.createElement("path", {
    d: "M 50 60 Q 100 40 150 60 T 250 60 T 350 60 T 450 60"
  }), "&#xa;    &#xa;    ", /*#__PURE__*/React.createElement("path", {
    d: "M 30 100 Q 80 80 130 100 T 230 100 T 330 100 T 430 100"
  }), "&#xa;    &#xa;    ", /*#__PURE__*/React.createElement("path", {
    d: "M 70 140 Q 120 120 170 140 T 270 140 T 370 140 T 470 140"
  }), "&#xa;  ")), "&#xa;")))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "SbbP0l1plqLaMQE0WqTQ-5"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 91.4,
    y: -0.14,
    width: 60.93,
    height: 60.93,
    fill: "#cdeb8b",
    stroke: "#36393d",
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(205, 235, 139), rgb(32, 58, 0))",
      stroke: "light-dark(rgb(54, 57, 61), rgb(186, 189, 192))"
    }
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRaft6);
export default __webpack_public_path__ + "static/media/raft_6.b3238cc7701c4d5608e52db3ec9a5a3c.svg";
export { ForwardRef as ReactComponent };